{
  "level": "ab03",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:ab03",
    "objects": "AREAS.E3:ab03.e3",
    "mesh": "TREES.E3:ab03.e3"
  },
  "spawn_point": {
    "position": [
      -3430.9590948368923,
      -5151.6428056632685,
      1005.70556640625
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3430.9590948368923,
      -5051.6428056632685,
      1005.70556640625
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3523.0,
      -5236.00048828125,
      981.70556640625
    ],
    "bbox_max": [
      -3348.0,
      -5009.00048828125,
      1071.7071533203125
    ],
    "vertex_count": 3691,
    "vertices": [
      [
        -3400.0,
        -5014.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1031.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1031.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1020.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1020.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1031.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1031.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1020.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1020.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1020.70703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1020.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1020.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1031.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1020.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1020.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1031.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1031.70703125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1071.7071533203125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1071.7071533203125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1061.70703125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1061.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1064.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1066.30712890625
      ],
      [
        -3400.0,
        -5096.00048828125,
        1064.70703125
      ],
      [
        -3400.000244140625,
        -5096.50048828125,
        1064.7071533203125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1064.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1064.70703125
      ],
      [
        -3406.000244140625,
        -5096.00048828125,
        1066.3070068359375
      ],
      [
        -3406.000244140625,
        -5096.50048828125,
        1066.30712890625
      ],
      [
        -3406.0,
        -5096.00048828125,
        1066.30712890625
      ],
      [
        -3406.0,
        -5091.00048828125,
        1066.30712890625
      ],
      [
        -3388.75,
        -5015.00048828125,
        1061.70703125
      ],
      [
        -3370.0,
        -5015.00048828125,
        1056.9962158203125
      ],
      [
        -3371.08447265625,
        -5015.00048828125,
        1056.9962158203125
      ],
      [
        -3373.0,
        -5053.00048828125,
        1057.507080078125
      ],
      [
        -3370.0,
        -5053.00048828125,
        1056.70703125
      ],
      [
        -3371.0,
        -5053.00048828125,
        1041.70703125
      ],
      [
        -3371.0,
        -5053.00048828125,
        1056.9737548828125
      ],
      [
        -3371.0,
        -5009.00048828125,
        1056.70703125
      ],
      [
        -3371.0,
        -5015.00048828125,
        1056.70703125
      ],
      [
        -3371.0,
        -5015.00048828125,
        1056.9737548828125
      ],
      [
        -3371.0,
        -5015.00048828125,
        1056.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1041.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1041.70703125
      ],
      [
        -3380.0,
        -5028.00048828125,
        1041.70703125
      ],
      [
        -3380.0,
        -5020.00048828125,
        1041.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1041.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1041.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1041.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1041.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1041.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1041.70703125
      ],
      [
        -3418.0,
        -5106.0009765625,
        981.70703125
      ],
      [
        -3422.0,
        -5106.0009765625,
        981.70703125
      ],
      [
        -3449.0,
        -5106.0009765625,
        981.70703125
      ],
      [
        -3453.0,
        -5106.0009765625,
        981.70703125
      ],
      [
        -3497.5,
        -5080.50048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5083.50048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5099.00048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5102.00048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5089.50048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5092.50048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5099.00048828125,
        1003.70703125
      ],
      [
        -3494.5,
        -5099.00048828125,
        1003.70703125
      ],
      [
        -3494.5,
        -5099.00048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5099.00048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5102.00048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5102.00048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5102.00048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5102.00048828125,
        1006.70703125
      ],
      [
        -3496.260986328125,
        -5120.97802734375,
        1003.70703125
      ],
      [
        -3494.5,
        -5122.1162109375,
        1004.8983154296875
      ],
      [
        -3494.5,
        -5123.52392578125,
        1006.70703125
      ],
      [
        -3496.774658203125,
        -5123.2509765625,
        1006.70703125
      ],
      [
        -3496.9677734375,
        -5120.8935546875,
        1003.70703125
      ],
      [
        -3496.9677734375,
        -5120.8935546875,
        1003.70703125
      ],
      [
        -3496.774658203125,
        -5123.2509765625,
        1006.70703125
      ],
      [
        -3497.5,
        -5123.205078125,
        1006.70703125
      ],
      [
        -3497.5,
        -5120.85986328125,
        1003.70703125
      ],
      [
        -3494.5,
        -5120.60986328125,
        1005.0942993164062
      ],
      [
        -3496.337646484375,
        -5120.529296875,
        1003.70703125
      ],
      [
        -3494.5,
        -5118.79052734375,
        1003.70703125
      ],
      [
        -3496.337646484375,
        -5120.529296875,
        1003.70703125
      ],
      [
        -3494.5,
        -5120.60986328125,
        1005.0942993164062
      ],
      [
        -3494.5,
        -5122.1162109375,
        1004.8983154296875
      ],
      [
        -3496.260986328125,
        -5120.97802734375,
        1003.70703125
      ],
      [
        -3497.5,
        -5083.50048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5083.50048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5083.50048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5083.50048828125,
        1003.70703125
      ],
      [
        -3494.5,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5080.50048828125,
        1003.70703125
      ],
      [
        -3494.5,
        -5080.50048828125,
        1003.70703125
      ],
      [
        -3494.5,
        -5080.50048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5080.50048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5089.50048828125,
        1003.70703125
      ],
      [
        -3494.5,
        -5089.50048828125,
        1003.70703125
      ],
      [
        -3494.5,
        -5089.50048828125,
        1006.70703125
      ],
      [
        -3497.5,
        -5089.50048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5092.50048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5092.50048828125,
        1003.70703125
      ],
      [
        -3497.5,
        -5092.50048828125,
        1006.70703125
      ],
      [
        -3494.5,
        -5092.50048828125,
        1006.70703125
      ],
      [
        -3460.083251953125,
        -5202.25048828125,
        1006.70703125
      ],
      [
        -3457.958251953125,
        -5200.37548828125,
        1003.70703125
      ],
      [
        -3457.958251953125,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3460.083251953125,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3457.958251953125,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3460.083251953125,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3460.083251953125,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3457.958251953125,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3442.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3442.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3418.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3443.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3443.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3348.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3348.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3412.75,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3410.5,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5034.6005859375,
        1006.70703125
      ],
      [
        -3380.0,
        -5035.6005859375,
        1006.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5039.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5039.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5034.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5039.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5039.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5088.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5088.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5089.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5089.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5089.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5089.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5088.00048828125,
        1003.70703125
      ],
      [
        -3360.0,
        -5088.00048828125,
        1006.70703125
      ],
      [
        -3360.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3360.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5067.00048828125,
        1006.70703125
      ],
      [
        -3360.0,
        -5088.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5088.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5067.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5067.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5067.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3376.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3376.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3379.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3379.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3376.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3379.000244140625,
        -5087.00048828125,
        1003.70703125
      ],
      [
        -3378.0,
        -5086.00048828125,
        1005.70703125
      ],
      [
        -3379.000244140625,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3376.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3376.0,
        -5103.00048828125,
        1005.70703125
      ],
      [
        -3378.0,
        -5103.00048828125,
        1005.70703125
      ],
      [
        -3380.0,
        -5088.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5085.00048828125,
        1003.70703125
      ],
      [
        -3379.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5103.00048828125,
        1005.70703125
      ],
      [
        -3380.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3376.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5095.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5095.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5095.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5095.00048828125,
        1003.70703125
      ],
      [
        -3368.199951171875,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3368.199951171875,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3368.199951171875,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3368.199951171875,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3368.199951171875,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3368.199951171875,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3373.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3373.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3368.199951171875,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3368.199951171875,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3373.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3373.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3373.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3373.0,
        -5095.00048828125,
        1003.70703125
      ],
      [
        -3373.0,
        -5095.00048828125,
        1006.70703125
      ],
      [
        -3362.5,
        -5091.0,
        1006.70703125
      ],
      [
        -3362.5,
        -5094.0,
        1006.70703125
      ],
      [
        -3362.5,
        -5094.0,
        1006.70703125
      ],
      [
        -3362.0,
        -5094.0,
        1006.70703125
      ],
      [
        -3362.5,
        -5091.0,
        1006.70703125
      ],
      [
        -3362.0,
        -5091.0,
        1006.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5039.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5039.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5034.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5039.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5039.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3425.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3425.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3425.0,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3425.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5087.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5087.00048828125,
        1006.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3427.121337890625,
        -5084.87939453125,
        1006.70703125
      ],
      [
        -3427.121337890625,
        -5084.87939453125,
        1003.70703125
      ],
      [
        -3425.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3425.0,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3428.0,
        -5087.00048828125,
        1006.70703125
      ],
      [
        -3428.0,
        -5087.00048828125,
        1003.70703125
      ],
      [
        -3427.121337890625,
        -5084.87939453125,
        1003.70703125
      ],
      [
        -3427.121337890625,
        -5084.87939453125,
        1006.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1003.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3406.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3406.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5087.00048828125,
        1006.70703125
      ],
      [
        -3443.0,
        -5087.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3443.0,
        -5087.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5087.00048828125,
        1006.70703125
      ],
      [
        -3441.75732421875,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3441.75732421875,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3437.72802734375,
        -5074.2724609375,
        1003.70703125
      ],
      [
        -3437.72802734375,
        -5074.2724609375,
        1006.70703125
      ],
      [
        -3425.0,
        -5069.00048828125,
        1006.70703125
      ],
      [
        -3425.0,
        -5069.00048828125,
        1003.70703125
      ],
      [
        -3437.72802734375,
        -5074.2724609375,
        1006.70703125
      ],
      [
        -3437.72802734375,
        -5074.2724609375,
        1003.70703125
      ],
      [
        -3380.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3382.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3382.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1003.70703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3380.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3380.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5103.00048828125,
        1006.70703125
      ],
      [
        -3400.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3374.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3377.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3377.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3374.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3377.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3374.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3374.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3377.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3374.5,
        -5189.49560546875,
        1005.5852661132812
      ],
      [
        -3374.677001953125,
        -5189.49609375,
        1006.70703125
      ],
      [
        -3374.5,
        -5189.92333984375,
        1006.70703125
      ],
      [
        -3374.5,
        -5189.06884765625,
        1006.70703125
      ],
      [
        -3374.677001953125,
        -5189.49609375,
        1006.70703125
      ],
      [
        -3374.5,
        -5189.49560546875,
        1005.5852661132812
      ],
      [
        -3365.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3368.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3368.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3365.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3368.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3365.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3365.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3368.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3365.5,
        -5210.00048828125,
        1004.2982788085938
      ],
      [
        -3365.5,
        -5207.00048828125,
        1004.2982177734375
      ],
      [
        -3368.5,
        -5207.00048828125,
        1006.1851196289062
      ],
      [
        -3366.7587890625,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3368.5,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3365.5,
        -5207.00048828125,
        1004.2982177734375
      ],
      [
        -3365.5,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3366.7587890625,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3365.5,
        -5210.00048828125,
        1004.2982788085938
      ],
      [
        -3366.758544921875,
        -5210.00048828125,
        1006.70703125
      ],
      [
        -3365.5,
        -5210.00048828125,
        1006.70703125
      ],
      [
        -3366.758544921875,
        -5210.00048828125,
        1006.70703125
      ],
      [
        -3368.5,
        -5210.00048828125,
        1006.1856689453125
      ],
      [
        -3368.5,
        -5210.00048828125,
        1006.70703125
      ],
      [
        -3368.5,
        -5210.00048828125,
        1006.1856689453125
      ],
      [
        -3368.5,
        -5207.00048828125,
        1006.1851196289062
      ],
      [
        -3365.5,
        -5113.07177734375,
        1006.70703125
      ],
      [
        -3365.5,
        -5113.07177734375,
        1003.70703125
      ],
      [
        -3359.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3352.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3352.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3359.5,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3348.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3348.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3348.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3348.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3368.7265625,
        -5210.00048828125,
        1006.70703125
      ],
      [
        -3368.726806640625,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3368.726806640625,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3368.7265625,
        -5210.00048828125,
        1006.70703125
      ],
      [
        -3370.9814453125,
        -5191.02685546875,
        1006.70703125
      ],
      [
        -3370.347412109375,
        -5189.49609375,
        1006.70703125
      ],
      [
        -3372.512451171875,
        -5191.6611328125,
        1006.70703125
      ],
      [
        -3370.9814453125,
        -5191.02685546875,
        1006.70703125
      ],
      [
        -3370.347412109375,
        -5189.49609375,
        1006.70703125
      ],
      [
        -3370.9814453125,
        -5187.9658203125,
        1006.70703125
      ],
      [
        -3370.9814453125,
        -5187.9658203125,
        1006.70703125
      ],
      [
        -3372.512451171875,
        -5187.33154296875,
        1006.70703125
      ],
      [
        -3374.04296875,
        -5191.02685546875,
        1006.70703125
      ],
      [
        -3372.512451171875,
        -5191.6611328125,
        1006.70703125
      ],
      [
        -3372.512451171875,
        -5187.33154296875,
        1006.70703125
      ],
      [
        -3374.04296875,
        -5187.9658203125,
        1006.70703125
      ],
      [
        -3374.04296875,
        -5191.02685546875,
        1006.70703125
      ],
      [
        -3374.04296875,
        -5187.9658203125,
        1006.70703125
      ],
      [
        -3374.237548828125,
        -5189.41259765625,
        1003.70703125
      ],
      [
        -3373.79150390625,
        -5188.3359375,
        1003.70703125
      ],
      [
        -3374.271484375,
        -5189.49462890625,
        1003.70703125
      ],
      [
        -3373.791748046875,
        -5190.6533203125,
        1003.70703125
      ],
      [
        -3374.271484375,
        -5189.49462890625,
        1003.70703125
      ],
      [
        -3373.757568359375,
        -5188.25390625,
        1003.70703125
      ],
      [
        -3372.59912109375,
        -5187.77392578125,
        1003.70703125
      ],
      [
        -3373.757568359375,
        -5188.25390625,
        1003.70703125
      ],
      [
        -3373.757568359375,
        -5190.73583984375,
        1003.70703125
      ],
      [
        -3372.60107421875,
        -5191.21484375,
        1003.70703125
      ],
      [
        -3373.757568359375,
        -5190.73583984375,
        1003.70703125
      ],
      [
        -3372.5166015625,
        -5187.73974609375,
        1003.70703125
      ],
      [
        -3371.359375,
        -5188.21923828125,
        1003.70703125
      ],
      [
        -3372.5166015625,
        -5187.73974609375,
        1003.70703125
      ],
      [
        -3371.275390625,
        -5188.25390625,
        1003.70703125
      ],
      [
        -3370.796142578125,
        -5189.41064453125,
        1003.70703125
      ],
      [
        -3371.275390625,
        -5188.25390625,
        1003.70703125
      ],
      [
        -3372.5166015625,
        -5191.25,
        1003.70703125
      ],
      [
        -3371.359619140625,
        -5190.7705078125,
        1003.70703125
      ],
      [
        -3372.5166015625,
        -5191.25,
        1003.70703125
      ],
      [
        -3371.275390625,
        -5190.73583984375,
        1003.70703125
      ],
      [
        -3370.761474609375,
        -5189.49462890625,
        1003.70703125
      ],
      [
        -3371.275390625,
        -5190.73583984375,
        1003.70703125
      ],
      [
        -3370.761474609375,
        -5189.49462890625,
        1003.70703125
      ],
      [
        -3457.958251953125,
        -5200.37548828125,
        1003.70703125
      ],
      [
        -3460.083251953125,
        -5202.25048828125,
        1006.70703125
      ],
      [
        -3410.5,
        -5202.25048828125,
        1006.70703125
      ],
      [
        -3412.75,
        -5200.37548828125,
        1003.70703125
      ],
      [
        -3410.5,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3412.75,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3412.75,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3410.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3410.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3412.75,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3412.75,
        -5200.37548828125,
        1003.70703125
      ],
      [
        -3410.5,
        -5202.25048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5196.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5196.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5196.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5196.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5196.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5196.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3457.958251953125,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3460.0830078125,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3455.08056640625,
        -5175.34521484375,
        1006.70703125
      ],
      [
        -3458.056884765625,
        -5175.8388671875,
        1003.8463134765625
      ],
      [
        -3457.958251953125,
        -5175.6474609375,
        1003.70703125
      ],
      [
        -3453.0,
        -5171.26220703125,
        1003.70703125
      ],
      [
        -3453.0,
        -5173.50537109375,
        1006.70703125
      ],
      [
        -3456.723876953125,
        -5176.98046875,
        1006.70703125
      ],
      [
        -3459.157470703125,
        -5178.2744140625,
        1005.4000854492188
      ],
      [
        -3458.056884765625,
        -5175.8388671875,
        1003.8463134765625
      ],
      [
        -3455.08056640625,
        -5175.34521484375,
        1006.70703125
      ],
      [
        -3459.27197265625,
        -5179.1689453125,
        1006.70703125
      ],
      [
        -3459.68115234375,
        -5179.1748046875,
        1006.1397094726562
      ],
      [
        -3459.157470703125,
        -5178.2744140625,
        1005.4000854492188
      ],
      [
        -3456.723876953125,
        -5176.98046875,
        1006.70703125
      ],
      [
        -3459.68115234375,
        -5179.1748046875,
        1006.1397094726562
      ],
      [
        -3459.27197265625,
        -5179.1689453125,
        1006.70703125
      ],
      [
        -3460.0830078125,
        -5179.80419921875,
        1006.70703125
      ],
      [
        -3460.0830078125,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3457.958251953125,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5196.00048828125,
        1006.70703125
      ],
      [
        -3418.0,
        -5196.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3418.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3418.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3410.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3418.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3418.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3412.749755859375,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3410.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3412.749755859375,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3442.0,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3442.0,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3443.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3442.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3442.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3439.5,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3431.5,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3442.0,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3439.5,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3431.5,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3429.0,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3439.5,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3439.5,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3431.5,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3431.5,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3384.0,
        -5126.75927734375,
        1006.70703125
      ],
      [
        -3384.0,
        -5126.75927734375,
        1006.70703125
      ],
      [
        -3384.0,
        -5128.72705078125,
        1006.70703125
      ],
      [
        -3387.0,
        -5126.75927734375,
        1006.70703125
      ],
      [
        -3387.0,
        -5128.72705078125,
        1006.70703125
      ],
      [
        -3387.0,
        -5126.75927734375,
        1006.70703125
      ],
      [
        -3384.0,
        -5128.72705078125,
        1006.70703125
      ],
      [
        -3387.0,
        -5128.72705078125,
        1006.70703125
      ],
      [
        -3384.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3387.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3387.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3384.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3387.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3384.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3384.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3387.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3412.75,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3410.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3412.75,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3410.5,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3410.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3412.75,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3401.60986328125,
        -5130.08154296875,
        1003.70703125
      ],
      [
        -3403.541748046875,
        -5130.1787109375,
        1006.70703125
      ],
      [
        -3402.95703125,
        -5121.4345703125,
        1006.70703125
      ],
      [
        -3400.85986328125,
        -5118.86572265625,
        1003.70703125
      ],
      [
        -3401.375244140625,
        -5116.87890625,
        1003.70703125
      ],
      [
        -3404.123779296875,
        -5116.93603515625,
        1006.70703125
      ],
      [
        -3406.317138671875,
        -5109.7490234375,
        1006.70703125
      ],
      [
        -3404.5078125,
        -5106.61328125,
        1003.70703125
      ],
      [
        -3404.5078125,
        -5106.61328125,
        1003.70703125
      ],
      [
        -3406.317138671875,
        -5109.7490234375,
        1006.70703125
      ],
      [
        -3408.4677734375,
        -5104.00048828125,
        1006.70703125
      ],
      [
        -3405.4853515625,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3404.8935546875,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3407.1220703125,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3405.536865234375,
        -5132.8681640625,
        1006.70703125
      ],
      [
        -3402.516845703125,
        -5131.30419921875,
        1003.70703125
      ],
      [
        -3400.85986328125,
        -5118.86572265625,
        1003.70703125
      ],
      [
        -3402.95703125,
        -5121.4345703125,
        1006.70703125
      ],
      [
        -3404.123779296875,
        -5116.93603515625,
        1006.70703125
      ],
      [
        -3401.375244140625,
        -5116.87890625,
        1003.70703125
      ],
      [
        -3402.516845703125,
        -5131.30419921875,
        1003.70703125
      ],
      [
        -3405.536865234375,
        -5132.8681640625,
        1006.70703125
      ],
      [
        -3403.541748046875,
        -5130.1787109375,
        1006.70703125
      ],
      [
        -3401.60986328125,
        -5130.08154296875,
        1003.70703125
      ],
      [
        -3388.273193359375,
        -5188.00048828125,
        1006.70703125
      ],
      [
        -3390.2412109375,
        -5188.00048828125,
        1006.70703125
      ],
      [
        -3390.2412109375,
        -5188.00048828125,
        1006.70703125
      ],
      [
        -3390.241455078125,
        -5185.00048828125,
        1006.70703125
      ],
      [
        -3390.241455078125,
        -5185.00048828125,
        1006.70703125
      ],
      [
        -3388.2734375,
        -5185.00048828125,
        1006.70703125
      ],
      [
        -3388.2734375,
        -5185.00048828125,
        1006.70703125
      ],
      [
        -3388.273193359375,
        -5188.00048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5193.50048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5193.50048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5191.00048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5191.00048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5191.00048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5191.00048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5193.50048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5193.50048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5202.25048828125,
        1006.70703125
      ],
      [
        -3453.0,
        -5200.37548828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5236.00048828125,
        1003.70703125
      ],
      [
        -3453.0,
        -5236.00048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5204.50048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5204.50048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5204.50048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5204.50048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5207.00048828125,
        1003.70703125
      ],
      [
        -3396.5,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3396.5,
        -5207.00048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        1006.70703125
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        1003.70703125
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        1006.70703125
      ],
      [
        -3379.029296875,
        -5207.54443359375,
        1006.70703125
      ],
      [
        -3379.904296875,
        -5205.431640625,
        1006.70703125
      ],
      [
        -3379.904296875,
        -5209.65673828125,
        1006.70703125
      ],
      [
        -3379.029296875,
        -5207.54443359375,
        1006.70703125
      ],
      [
        -3379.904296875,
        -5205.431640625,
        1006.70703125
      ],
      [
        -3382.016845703125,
        -5204.55712890625,
        1006.70703125
      ],
      [
        -3382.016845703125,
        -5210.53173828125,
        1006.70703125
      ],
      [
        -3379.904296875,
        -5209.65673828125,
        1006.70703125
      ],
      [
        -3382.016845703125,
        -5204.55712890625,
        1006.70703125
      ],
      [
        -3384.12939453125,
        -5205.431640625,
        1006.70703125
      ],
      [
        -3384.12939453125,
        -5205.431640625,
        1006.70703125
      ],
      [
        -3385.00439453125,
        -5207.54443359375,
        1006.70703125
      ],
      [
        -3384.12939453125,
        -5209.65673828125,
        1006.70703125
      ],
      [
        -3382.016845703125,
        -5210.53173828125,
        1006.70703125
      ],
      [
        -3385.00439453125,
        -5207.54443359375,
        1006.70703125
      ],
      [
        -3384.12939453125,
        -5209.65673828125,
        1006.70703125
      ],
      [
        -3383.7822265625,
        -5209.1455078125,
        1003.70703125
      ],
      [
        -3384.39794921875,
        -5207.65966796875,
        1003.70703125
      ],
      [
        -3383.7353515625,
        -5209.2587890625,
        1003.70703125
      ],
      [
        -3382.13671875,
        -5209.9208984375,
        1003.70703125
      ],
      [
        -3383.7353515625,
        -5209.2587890625,
        1003.70703125
      ],
      [
        -3384.44482421875,
        -5207.54638671875,
        1003.70703125
      ],
      [
        -3383.783203125,
        -5205.94921875,
        1003.70703125
      ],
      [
        -3384.44482421875,
        -5207.54638671875,
        1003.70703125
      ],
      [
        -3383.7353515625,
        -5205.83349609375,
        1003.70703125
      ],
      [
        -3382.137451171875,
        -5205.171875,
        1003.70703125
      ],
      [
        -3383.7353515625,
        -5205.83349609375,
        1003.70703125
      ],
      [
        -3382.022705078125,
        -5209.96826171875,
        1003.70703125
      ],
      [
        -3380.42529296875,
        -5209.306640625,
        1003.70703125
      ],
      [
        -3382.022705078125,
        -5209.96826171875,
        1003.70703125
      ],
      [
        -3382.022705078125,
        -5205.12451171875,
        1003.70703125
      ],
      [
        -3380.426025390625,
        -5205.78564453125,
        1003.70703125
      ],
      [
        -3382.022705078125,
        -5205.12451171875,
        1003.70703125
      ],
      [
        -3380.31005859375,
        -5209.2587890625,
        1003.70703125
      ],
      [
        -3379.648681640625,
        -5207.662109375,
        1003.70703125
      ],
      [
        -3380.31005859375,
        -5209.2587890625,
        1003.70703125
      ],
      [
        -3379.6005859375,
        -5207.54638671875,
        1003.70703125
      ],
      [
        -3380.31005859375,
        -5205.83349609375,
        1003.70703125
      ],
      [
        -3380.31005859375,
        -5205.83349609375,
        1003.70703125
      ],
      [
        -3379.6005859375,
        -5207.54638671875,
        1003.70703125
      ],
      [
        -3488.0,
        -5181.24169921875,
        1006.70703125
      ],
      [
        -3488.0,
        -5181.24169921875,
        1006.70703125
      ],
      [
        -3488.0,
        -5179.27392578125,
        1006.70703125
      ],
      [
        -3485.0,
        -5181.24169921875,
        1006.70703125
      ],
      [
        -3485.0,
        -5179.27392578125,
        1006.70703125
      ],
      [
        -3485.0,
        -5181.24169921875,
        1006.70703125
      ],
      [
        -3488.0,
        -5179.27392578125,
        1006.70703125
      ],
      [
        -3485.0,
        -5179.27392578125,
        1006.70703125
      ],
      [
        -3488.0,
        -5099.00048828125,
        1003.70703125
      ],
      [
        -3485.0,
        -5099.00048828125,
        1003.70703125
      ],
      [
        -3485.0,
        -5099.00048828125,
        1006.70703125
      ],
      [
        -3488.0,
        -5099.00048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5102.00048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5102.00048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5102.00048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5102.00048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5120.28076171875,
        1005.8004150390625
      ],
      [
        -3486.2802734375,
        -5120.4404296875,
        1006.70703125
      ],
      [
        -3488.0,
        -5120.0908203125,
        1006.70703125
      ],
      [
        -3488.0,
        -5118.701171875,
        1003.70703125
      ],
      [
        -3485.0,
        -5119.31103515625,
        1003.70703125
      ],
      [
        -3485.0,
        -5121.0361328125,
        1006.70703125
      ],
      [
        -3486.2802734375,
        -5120.4404296875,
        1006.70703125
      ],
      [
        -3485.0,
        -5120.28076171875,
        1005.8004150390625
      ],
      [
        -3488.0,
        -5083.50048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5083.50048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5083.50048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5083.50048828125,
        1003.70703125
      ],
      [
        -3485.0,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3488.0,
        -5080.50048828125,
        1003.70703125
      ],
      [
        -3485.0,
        -5080.50048828125,
        1003.70703125
      ],
      [
        -3485.0,
        -5080.50048828125,
        1006.70703125
      ],
      [
        -3488.0,
        -5080.50048828125,
        1006.70703125
      ],
      [
        -3488.0,
        -5089.50048828125,
        1003.70703125
      ],
      [
        -3485.0,
        -5089.50048828125,
        1003.70703125
      ],
      [
        -3485.0,
        -5089.50048828125,
        1006.70703125
      ],
      [
        -3488.0,
        -5089.50048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5092.50048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5092.50048828125,
        1003.70703125
      ],
      [
        -3488.0,
        -5092.50048828125,
        1006.70703125
      ],
      [
        -3485.0,
        -5092.50048828125,
        1006.70703125
      ],
      [
        -3460.083251953125,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3457.958251953125,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3460.083251953125,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3457.958251953125,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3466.1767578125,
        -5209.87158203125,
        1003.70703125
      ],
      [
        -3463.98876953125,
        -5209.71630859375,
        1006.70703125
      ],
      [
        -3466.022216796875,
        -5218.517578125,
        1006.70703125
      ],
      [
        -3468.63916015625,
        -5220.529296875,
        1003.70703125
      ],
      [
        -3468.63916015625,
        -5225.73876953125,
        1003.70703125
      ],
      [
        -3466.688232421875,
        -5223.107421875,
        1006.70703125
      ],
      [
        -3464.682861328125,
        -5230.251953125,
        1006.70703125
      ],
      [
        -3466.4921875,
        -5233.3876953125,
        1003.70703125
      ],
      [
        -3466.4921875,
        -5233.3876953125,
        1003.70703125
      ],
      [
        -3464.682861328125,
        -5230.251953125,
        1006.70703125
      ],
      [
        -3462.5322265625,
        -5236.00048828125,
        1006.70703125
      ],
      [
        -3465.5146484375,
        -5236.00048828125,
        1003.70703125
      ],
      [
        -3466.022216796875,
        -5218.517578125,
        1006.70703125
      ],
      [
        -3466.688232421875,
        -5223.107421875,
        1006.70703125
      ],
      [
        -3468.63916015625,
        -5220.529296875,
        1003.70703125
      ],
      [
        -3469.06787109375,
        -5223.21533203125,
        1003.70703125
      ],
      [
        -3469.118896484375,
        -5223.74267578125,
        1003.70703125
      ],
      [
        -3468.63916015625,
        -5225.73876953125,
        1003.70703125
      ],
      [
        -3469.06787109375,
        -5223.21533203125,
        1003.70703125
      ],
      [
        -3469.118896484375,
        -5223.74267578125,
        1003.70703125
      ],
      [
        -3458.35400390625,
        -5176.0146484375,
        1003.70703125
      ],
      [
        -3458.20166015625,
        -5175.86279296875,
        1003.70703125
      ],
      [
        -3458.161376953125,
        -5176.06982421875,
        1003.9937744140625
      ],
      [
        -3458.20166015625,
        -5175.86279296875,
        1003.70703125
      ],
      [
        -3464.0458984375,
        -5190.3876953125,
        1006.70703125
      ],
      [
        -3466.4921875,
        -5190.728515625,
        1003.70703125
      ],
      [
        -3467.00634765625,
        -5189.68701171875,
        1003.70703125
      ],
      [
        -3465.142822265625,
        -5188.16552734375,
        1006.70703125
      ],
      [
        -3467.36328125,
        -5185.0908203125,
        1003.70703125
      ],
      [
        -3465.3994140625,
        -5184.86376953125,
        1006.70703125
      ],
      [
        -3465.142822265625,
        -5188.16552734375,
        1006.70703125
      ],
      [
        -3467.00634765625,
        -5189.68701171875,
        1003.70703125
      ],
      [
        -3461.502197265625,
        -5179.361328125,
        1003.70703125
      ],
      [
        -3462.787353515625,
        -5180.62060546875,
        1003.70703125
      ],
      [
        -3462.787353515625,
        -5180.62060546875,
        1003.70703125
      ],
      [
        -3460.771728515625,
        -5180.34326171875,
        1006.70703125
      ],
      [
        -3465.3994140625,
        -5184.86376953125,
        1006.70703125
      ],
      [
        -3467.36328125,
        -5185.0908203125,
        1003.70703125
      ],
      [
        -3458.59912109375,
        -5177.03857421875,
        1004.6118774414062
      ],
      [
        -3460.771728515625,
        -5180.34326171875,
        1006.70703125
      ],
      [
        -3460.900634765625,
        -5178.54833984375,
        1003.70703125
      ],
      [
        -3461.502197265625,
        -5179.361328125,
        1003.70703125
      ],
      [
        -3460.900634765625,
        -5178.54833984375,
        1003.70703125
      ],
      [
        -3466.853271484375,
        -5194.3740234375,
        1003.70703125
      ],
      [
        -3464.277099609375,
        -5192.72216796875,
        1006.70703125
      ],
      [
        -3463.763671875,
        -5195.85302734375,
        1006.70703125
      ],
      [
        -3466.051513671875,
        -5199.26318359375,
        1003.70703125
      ],
      [
        -3466.4921875,
        -5190.728515625,
        1003.70703125
      ],
      [
        -3464.0458984375,
        -5190.3876953125,
        1006.70703125
      ],
      [
        -3464.277099609375,
        -5192.72216796875,
        1006.70703125
      ],
      [
        -3466.853271484375,
        -5194.3740234375,
        1003.70703125
      ],
      [
        -3466.1064453125,
        -5200.89453125,
        1003.70703125
      ],
      [
        -3463.8779296875,
        -5199.24658203125,
        1006.70703125
      ],
      [
        -3463.89697265625,
        -5203.28369140625,
        1006.70703125
      ],
      [
        -3466.135009765625,
        -5206.947265625,
        1003.70703125
      ],
      [
        -3463.8779296875,
        -5199.24658203125,
        1006.70703125
      ],
      [
        -3466.1064453125,
        -5200.89453125,
        1003.70703125
      ],
      [
        -3466.051513671875,
        -5199.26318359375,
        1003.70703125
      ],
      [
        -3463.763671875,
        -5195.85302734375,
        1006.70703125
      ],
      [
        -3466.135009765625,
        -5206.947265625,
        1003.70703125
      ],
      [
        -3463.89697265625,
        -5203.28369140625,
        1006.70703125
      ],
      [
        -3463.98876953125,
        -5209.71630859375,
        1006.70703125
      ],
      [
        -3466.1767578125,
        -5209.87158203125,
        1003.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3467.619873046875,
        -5126.44775390625,
        1003.70703125
      ],
      [
        -3467.84375,
        -5128.27734375,
        1006.70703125
      ],
      [
        -3471.740234375,
        -5125.12353515625,
        1006.70703125
      ],
      [
        -3472.03466796875,
        -5122.87451171875,
        1003.70703125
      ],
      [
        -3463.980224609375,
        -5132.2763671875,
        1006.70703125
      ],
      [
        -3465.69384765625,
        -5128.27734375,
        1003.70703125
      ],
      [
        -3462.7626953125,
        -5131.97802734375,
        1003.70703125
      ],
      [
        -3462.30517578125,
        -5134.3916015625,
        1006.70703125
      ],
      [
        -3481.999755859375,
        -5120.05615234375,
        1003.70703125
      ],
      [
        -3477.728271484375,
        -5122.50830078125,
        1003.70703125
      ],
      [
        -3477.3876953125,
        -5124.95458984375,
        1006.70703125
      ],
      [
        -3480.846923828125,
        -5122.96875,
        1006.70703125
      ],
      [
        -3480.846923828125,
        -5122.96875,
        1006.70703125
      ],
      [
        -3482.961181640625,
        -5119.69580078125,
        1003.70703125
      ],
      [
        -3482.728271484375,
        -5119.71240234375,
        1003.70703125
      ],
      [
        -3483.1787109375,
        -5119.681640625,
        1003.70703125
      ],
      [
        -3482.961181640625,
        -5119.69580078125,
        1003.70703125
      ],
      [
        -3482.728271484375,
        -5119.71240234375,
        1003.70703125
      ],
      [
        -3481.999755859375,
        -5120.05615234375,
        1003.70703125
      ],
      [
        -3483.1787109375,
        -5119.681640625,
        1003.70703125
      ],
      [
        -3472.03466796875,
        -5122.87451171875,
        1003.70703125
      ],
      [
        -3471.740234375,
        -5125.12353515625,
        1006.70703125
      ],
      [
        -3474.33056640625,
        -5124.87939453125,
        1006.70703125
      ],
      [
        -3476.29541015625,
        -5122.47314453125,
        1003.70703125
      ],
      [
        -3466.16845703125,
        -5129.728515625,
        1006.70703125
      ],
      [
        -3463.980224609375,
        -5132.2763671875,
        1006.70703125
      ],
      [
        -3477.3876953125,
        -5124.95458984375,
        1006.70703125
      ],
      [
        -3477.728271484375,
        -5122.50830078125,
        1003.70703125
      ],
      [
        -3476.29541015625,
        -5122.47314453125,
        1003.70703125
      ],
      [
        -3474.33056640625,
        -5124.87939453125,
        1006.70703125
      ],
      [
        -3467.84375,
        -5128.27734375,
        1006.70703125
      ],
      [
        -3466.16845703125,
        -5129.728515625,
        1006.70703125
      ],
      [
        -3466.34375,
        -5127.56103515625,
        1003.70703125
      ],
      [
        -3467.619873046875,
        -5126.44775390625,
        1003.70703125
      ],
      [
        -3466.34375,
        -5127.56103515625,
        1003.70703125
      ],
      [
        -3465.69384765625,
        -5128.27734375,
        1003.70703125
      ],
      [
        -3462.30517578125,
        -5134.3916015625,
        1006.70703125
      ],
      [
        -3462.7626953125,
        -5131.97802734375,
        1003.70703125
      ],
      [
        -3458.26171875,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3460.504638671875,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3490.8125,
        -5118.12939453125,
        1003.70703125
      ],
      [
        -3490.01220703125,
        -5119.681640625,
        1006.70703125
      ],
      [
        -3491.25146484375,
        -5119.650390625,
        1006.70703125
      ],
      [
        -3493.724365234375,
        -5118.056640625,
        1003.70703125
      ],
      [
        -3490.01220703125,
        -5119.681640625,
        1006.70703125
      ],
      [
        -3490.8125,
        -5118.12939453125,
        1003.70703125
      ],
      [
        -3492.36376953125,
        -5120.703125,
        1006.70703125
      ],
      [
        -3491.826416015625,
        -5123.8447265625,
        1006.70703125
      ],
      [
        -3493.724365234375,
        -5118.056640625,
        1003.70703125
      ],
      [
        -3491.25146484375,
        -5119.650390625,
        1006.70703125
      ],
      [
        -3492.36376953125,
        -5120.703125,
        1006.70703125
      ],
      [
        -3491.826416015625,
        -5123.8447265625,
        1006.70703125
      ],
      [
        -3383.000244140625,
        -5014.00048828125,
        1014.20703125
      ],
      [
        -3397.0,
        -5014.00048828125,
        1014.20703125
      ],
      [
        -3400.0,
        -5014.00048828125,
        1014.20703125
      ],
      [
        -3380.0,
        -5014.00048828125,
        1014.20703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1016.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1016.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1016.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1016.70703125
      ],
      [
        -3400.0,
        -5096.00048828125,
        1016.70703125
      ],
      [
        -3400.0,
        -5091.00048828125,
        1016.70703125
      ],
      [
        -3406.0,
        -5091.00048828125,
        1016.70703125
      ],
      [
        -3406.0,
        -5096.00048828125,
        1016.70703125
      ],
      [
        -3362.0,
        -5095.00048828125,
        1011.70703125
      ],
      [
        -3362.0,
        -5095.00048828125,
        1006.70703125
      ],
      [
        -3362.0,
        -5084.00048828125,
        1011.70703125
      ],
      [
        -3362.0,
        -5084.00048828125,
        1009.70703125
      ],
      [
        -3360.0,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3360.0,
        -5084.00048828125,
        1009.70703125
      ],
      [
        -3360.0,
        -5084.00048828125,
        1009.70703125
      ],
      [
        -3362.0,
        -5084.00048828125,
        1009.70703125
      ],
      [
        -3441.75732421875,
        -5084.00048828125,
        1016.70703125
      ],
      [
        -3441.75732421875,
        -5084.00048828125,
        1006.70703125
      ],
      [
        -3460.0830078125,
        -5166.00048828125,
        1006.70703125
      ],
      [
        -3469.999755859375,
        -5166.00048828125,
        1020.70703125
      ],
      [
        -3454.426513671875,
        -5209.90283203125,
        1018.95068359375
      ],
      [
        -3458.7578125,
        -5206.5703125,
        1013.6181640625
      ],
      [
        -3458.7578125,
        -5206.5703125,
        1013.6181640625
      ],
      [
        -3460.259033203125,
        -5205.39697265625,
        1011.7415161132812
      ],
      [
        -3459.420166015625,
        -5196.00048828125,
        1012.7088623046875
      ],
      [
        -3459.208251953125,
        -5196.00048828125,
        1012.9725952148438
      ],
      [
        -3461.935302734375,
        -5197.810546875,
        1009.3220825195312
      ],
      [
        -3459.487548828125,
        -5196.00048828125,
        1012.617431640625
      ],
      [
        -3459.447998046875,
        -5196.00048828125,
        1012.6707763671875
      ],
      [
        -3461.940673828125,
        -5200.0810546875,
        1009.3295288085938
      ],
      [
        -3459.487548828125,
        -5196.00048828125,
        1012.617431640625
      ],
      [
        -3461.935302734375,
        -5197.810546875,
        1009.3220825195312
      ],
      [
        -3461.9052734375,
        -5196.00048828125,
        1009.279541015625
      ],
      [
        -3461.940673828125,
        -5200.0810546875,
        1009.3295288085938
      ],
      [
        -3459.447998046875,
        -5196.00048828125,
        1012.6707763671875
      ],
      [
        -3459.420166015625,
        -5196.00048828125,
        1012.7088623046875
      ],
      [
        -3460.259033203125,
        -5205.39697265625,
        1011.7415161132812
      ],
      [
        -3461.967529296875,
        -5203.9130859375,
        1009.3675537109375
      ],
      [
        -3453.43115234375,
        -5210.74755859375,
        1020.302734375
      ],
      [
        -3454.426513671875,
        -5209.90283203125,
        1018.95068359375
      ],
      [
        -3453.0,
        -5211.00048828125,
        1020.70703125
      ],
      [
        -3453.43115234375,
        -5210.74755859375,
        1020.302734375
      ],
      [
        -3460.726318359375,
        -5180.81103515625,
        1007.6153564453125
      ],
      [
        -3460.0830078125,
        -5179.80419921875,
        1006.70703125
      ],
      [
        -3460.726318359375,
        -5180.81103515625,
        1007.6153564453125
      ],
      [
        -3462.845947265625,
        -5184.568359375,
        1010.6074829101562
      ],
      [
        -3461.85546875,
        -5193.0087890625,
        1009.209228515625
      ],
      [
        -3461.92529296875,
        -5190.09228515625,
        1009.3077392578125
      ],
      [
        -3462.77880859375,
        -5186.2353515625,
        1010.5128784179688
      ],
      [
        -3462.845947265625,
        -5184.568359375,
        1010.6074829101562
      ],
      [
        -3462.77880859375,
        -5186.2353515625,
        1010.5128784179688
      ],
      [
        -3461.97900390625,
        -5191.24853515625,
        1009.3833618164062
      ],
      [
        -3461.85546875,
        -5193.0087890625,
        1009.209228515625
      ],
      [
        -3461.92529296875,
        -5190.09228515625,
        1009.3077392578125
      ],
      [
        -3461.97900390625,
        -5191.24853515625,
        1009.3833618164062
      ],
      [
        -3396.5,
        -5204.50048828125,
        1010.3070068359375
      ],
      [
        -3396.5,
        -5207.00048828125,
        1014.3072509765625
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        1010.3070068359375
      ],
      [
        -3396.5,
        -5204.50048828125,
        1010.3070068359375
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        1014.3072509765625
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        1010.3070068359375
      ],
      [
        -3396.5,
        -5207.00048828125,
        1014.3072509765625
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        1014.3072509765625
      ],
      [
        -3387.10009765625,
        -5202.4384765625,
        1017.1095581054688
      ],
      [
        -3387.51904296875,
        -5207.53857421875,
        1015.1676635742188
      ],
      [
        -3387.10009765625,
        -5207.30712890625,
        1014.7972412109375
      ],
      [
        -3387.51904296875,
        -5207.53857421875,
        1015.1676635742188
      ],
      [
        -3390.916015625,
        -5211.00048828125,
        1020.70703125
      ],
      [
        -3387.10009765625,
        -5199.30078125,
        1020.70703125
      ],
      [
        -3387.10009765625,
        -5202.4384765625,
        1017.1095581054688
      ],
      [
        -3377.642822265625,
        -5206.896484375,
        1014.140380859375
      ],
      [
        -3379.26171875,
        -5204.794921875,
        1010.7783813476562
      ],
      [
        -3379.829833984375,
        -5198.08740234375,
        1020.70703125
      ],
      [
        -3386.357177734375,
        -5206.896484375,
        1014.140380859375
      ],
      [
        -3386.357177734375,
        -5206.896484375,
        1014.140380859375
      ],
      [
        -3385.558837890625,
        -5205.85009765625,
        1012.4664306640625
      ],
      [
        -3384.753662109375,
        -5204.794921875,
        1010.7783813476562
      ],
      [
        -3384.677490234375,
        -5204.771484375,
        1010.740966796875
      ],
      [
        -3384.753662109375,
        -5204.794921875,
        1010.7783813476562
      ],
      [
        -3379.26171875,
        -5204.794921875,
        1010.7783813476562
      ],
      [
        -3382.0107421875,
        -5203.955078125,
        1009.4337158203125
      ],
      [
        -3382.0107421875,
        -5203.955078125,
        1009.4337158203125
      ],
      [
        -3366.89990234375,
        -5207.00048828125,
        1014.307373046875
      ],
      [
        -3369.89990234375,
        -5207.00048828125,
        1014.307373046875
      ],
      [
        -3376.48095703125,
        -5207.53857421875,
        1015.1676635742188
      ],
      [
        -3371.872802734375,
        -5207.00048828125,
        1020.70703125
      ],
      [
        -3377.45458984375,
        -5207.00048828125,
        1014.3067626953125
      ],
      [
        -3373.083984375,
        -5211.00048828125,
        1020.70703125
      ],
      [
        -3376.48095703125,
        -5207.53857421875,
        1015.1676635742188
      ],
      [
        -3369.89990234375,
        -5207.00048828125,
        1014.307373046875
      ],
      [
        -3369.89990234375,
        -5210.00048828125,
        1019.1072387695312
      ],
      [
        -3366.89990234375,
        -5210.00048828125,
        1019.1072387695312
      ],
      [
        -3366.89990234375,
        -5207.00048828125,
        1014.307373046875
      ],
      [
        -3369.89990234375,
        -5210.00048828125,
        1019.1072387695312
      ],
      [
        -3366.89990234375,
        -5210.00048828125,
        1019.1072387695312
      ],
      [
        -3377.642822265625,
        -5206.896484375,
        1014.140380859375
      ],
      [
        -3379.35888671875,
        -5187.953125,
        1020.70703125
      ],
      [
        -3379.355224609375,
        -5191.05712890625,
        1020.70703125
      ],
      [
        -3374.48486328125,
        -5191.4775390625,
        1010.6842651367188
      ],
      [
        -3376.24462890625,
        -5183.5517578125,
        1020.70703125
      ],
      [
        -3376.236328125,
        -5195.45263671875,
        1020.70703125
      ],
      [
        -3370.931396484375,
        -5182.650390625,
        1020.70703125
      ],
      [
        -3370.927734375,
        -5196.34912109375,
        1020.70703125
      ],
      [
        -3366.54541015625,
        -5185.77001953125,
        1020.70703125
      ],
      [
        -3406.595947265625,
        -5125.8916015625,
        1011.91259765625
      ],
      [
        -3407.6298828125,
        -5117.00927734375,
        1010.5337524414062
      ],
      [
        -3408.181396484375,
        -5112.98046875,
        1009.7984619140625
      ],
      [
        -3409.626220703125,
        -5104.00048828125,
        1007.8722534179688
      ],
      [
        -3408.381103515625,
        -5134.34130859375,
        1009.5323486328125
      ],
      [
        -3406.756103515625,
        -5130.3408203125,
        1011.6988525390625
      ],
      [
        -3406.756103515625,
        -5130.3408203125,
        1011.6988525390625
      ],
      [
        -3406.595947265625,
        -5125.8916015625,
        1011.91259765625
      ],
      [
        -3407.6298828125,
        -5117.00927734375,
        1010.5337524414062
      ],
      [
        -3408.181396484375,
        -5112.98046875,
        1009.7984619140625
      ],
      [
        -3408.802978515625,
        -5136.00048828125,
        1008.9698486328125
      ],
      [
        -3408.381103515625,
        -5134.34130859375,
        1009.5323486328125
      ],
      [
        -3469.999755859375,
        -5136.00048828125,
        1020.70703125
      ],
      [
        -3460.0830078125,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3466.18310546875,
        -5135.84912109375,
        1015.3187866210938
      ],
      [
        -3465.064453125,
        -5136.00048828125,
        1013.7391967773438
      ],
      [
        -3466.028564453125,
        -5135.84326171875,
        1015.1004028320312
      ],
      [
        -3466.0791015625,
        -5135.8349609375,
        1015.1717529296875
      ],
      [
        -3466.0791015625,
        -5135.8349609375,
        1015.1717529296875
      ],
      [
        -3466.18310546875,
        -5135.84912109375,
        1015.3187866210938
      ],
      [
        -3462.567626953125,
        -5226.5859375,
        1010.2146606445312
      ],
      [
        -3461.10205078125,
        -5236.00048828125,
        1008.1455078125
      ],
      [
        -3462.32275390625,
        -5212.3232421875,
        1009.868896484375
      ],
      [
        -3463.011474609375,
        -5223.00341796875,
        1010.8411865234375
      ],
      [
        -3463.011474609375,
        -5223.00341796875,
        1010.8411865234375
      ],
      [
        -3462.567626953125,
        -5226.5859375,
        1010.2146606445312
      ],
      [
        -3462.00732421875,
        -5209.576171875,
        1009.4237670898438
      ],
      [
        -3462.32275390625,
        -5212.3232421875,
        1009.868896484375
      ],
      [
        -3462.00732421875,
        -5209.576171875,
        1009.4237670898438
      ],
      [
        -3461.990478515625,
        -5207.16943359375,
        1009.39990234375
      ],
      [
        -3386.87060546875,
        -5207.18017578125,
        1014.59423828125
      ],
      [
        -3389.896240234375,
        -5209.9609375,
        1019.0439453125
      ],
      [
        -3387.168212890625,
        -5215.74755859375,
        1020.70703125
      ],
      [
        -3379.8349609375,
        -5216.99169921875,
        1020.70703125
      ],
      [
        -3373.78271484375,
        -5212.68701171875,
        1020.70703125
      ],
      [
        -3497.5,
        -5064.00048828125,
        1020.70703125
      ],
      [
        -3497.5,
        -5136.00048828125,
        1020.70703125
      ],
      [
        -3483.0,
        -5129.57421875,
        1012.7088623046875
      ],
      [
        -3483.0,
        -5129.79248046875,
        1012.9725952148438
      ],
      [
        -3483.0,
        -5129.55078125,
        1012.6783447265625
      ],
      [
        -3483.0,
        -5129.57421875,
        1012.7088623046875
      ],
      [
        -3497.5,
        -5135.634765625,
        1020.3204956054688
      ],
      [
        -3497.5,
        -5126.8515625,
        1011.2750244140625
      ],
      [
        -3497.5,
        -5126.22900390625,
        1010.575439453125
      ],
      [
        -3497.5,
        -5126.22900390625,
        1010.575439453125
      ],
      [
        -3497.5,
        -5126.8515625,
        1011.2750244140625
      ],
      [
        -3497.5,
        -5136.00048828125,
        1020.70703125
      ],
      [
        -3497.5,
        -5135.634765625,
        1020.3204956054688
      ],
      [
        -3483.0,
        -5129.55078125,
        1012.6783447265625
      ],
      [
        -3491.869384765625,
        -5123.59423828125,
        1006.70703125
      ],
      [
        -3483.0,
        -5129.51318359375,
        1012.6832275390625
      ],
      [
        -3483.0,
        -5129.51318359375,
        1012.6832275390625
      ],
      [
        -3483.0,
        -5125.13818359375,
        1010.513916015625
      ],
      [
        -3483.0,
        -5125.13818359375,
        1010.513916015625
      ],
      [
        -3483.0,
        -5121.966796875,
        1006.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1020.70703125
      ],
      [
        -3483.0,
        -5129.79248046875,
        1012.9725952148438
      ],
      [
        -3473.341064453125,
        -5124.97265625,
        1006.70703125
      ],
      [
        -3461.69677734375,
        -5134.93505859375,
        1006.70703125
      ],
      [
        -3506.5,
        -5099.00048828125,
        1003.70703125
      ],
      [
        -3503.5,
        -5099.00048828125,
        1003.70703125
      ],
      [
        -3503.5,
        -5099.00048828125,
        1006.70703125
      ],
      [
        -3506.5,
        -5099.00048828125,
        1006.70703125
      ],
      [
        -3506.5,
        -5120.52490234375,
        1004.0089721679688
      ],
      [
        -3503.5,
        -5122.42626953125,
        1006.19775390625
      ],
      [
        -3503.5,
        -5122.87939453125,
        1006.70703125
      ],
      [
        -3506.5,
        -5122.92578125,
        1006.70703125
      ],
      [
        -3506.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3503.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3503.5,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3506.5,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3503.5,
        -5122.42626953125,
        1006.19775390625
      ],
      [
        -3506.5,
        -5120.52490234375,
        1004.0089721679688
      ],
      [
        -3506.5,
        -5120.2890625,
        1003.70703125
      ],
      [
        -3503.5,
        -5120.4794921875,
        1003.70703125
      ],
      [
        -3506.5,
        -5212.92919921875,
        1006.70703125
      ],
      [
        -3506.5,
        -5212.92919921875,
        1003.70703125
      ],
      [
        -3503.5,
        -5102.00048828125,
        1003.70703125
      ],
      [
        -3506.5,
        -5102.00048828125,
        1003.70703125
      ],
      [
        -3506.5,
        -5102.00048828125,
        1006.70703125
      ],
      [
        -3503.5,
        -5102.00048828125,
        1006.70703125
      ],
      [
        -3506.5,
        -5082.2578125,
        1006.70703125
      ],
      [
        -3506.5,
        -5082.2578125,
        1003.70703125
      ],
      [
        -3506.5,
        -5079.2578125,
        1003.70703125
      ],
      [
        -3506.5,
        -5079.2578125,
        1006.70703125
      ],
      [
        -3503.5,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3506.5,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3506.5,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3503.5,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3506.5,
        -5089.50048828125,
        1003.70703125
      ],
      [
        -3503.5,
        -5089.50048828125,
        1003.70703125
      ],
      [
        -3503.5,
        -5089.50048828125,
        1006.70703125
      ],
      [
        -3506.5,
        -5089.50048828125,
        1006.70703125
      ],
      [
        -3503.5,
        -5092.50048828125,
        1003.70703125
      ],
      [
        -3506.5,
        -5092.50048828125,
        1003.70703125
      ],
      [
        -3506.5,
        -5092.50048828125,
        1006.70703125
      ],
      [
        -3503.5,
        -5092.50048828125,
        1006.70703125
      ],
      [
        -3523.0,
        -5064.00048828125,
        1003.70703125
      ],
      [
        -3523.0,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3508.5,
        -5081.42919921875,
        1006.70703125
      ],
      [
        -3508.5,
        -5081.42919921875,
        1003.70703125
      ],
      [
        -3523.0,
        -5136.00048828125,
        1003.70703125
      ],
      [
        -3523.0,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3510.107177734375,
        -5120.31201171875,
        1003.70703125
      ],
      [
        -3510.031494140625,
        -5122.98046875,
        1006.70703125
      ],
      [
        -3515.436767578125,
        -5124.20703125,
        1006.70703125
      ],
      [
        -3519.562255859375,
        -5122.4580078125,
        1003.70703125
      ],
      [
        -3519.562255859375,
        -5122.4580078125,
        1003.70703125
      ],
      [
        -3515.436767578125,
        -5124.20703125,
        1006.70703125
      ],
      [
        -3523.0,
        -5126.46826171875,
        1006.70703125
      ],
      [
        -3523.0,
        -5123.48583984375,
        1003.70703125
      ],
      [
        -3506.913818359375,
        -5120.2626953125,
        1003.70703125
      ],
      [
        -3510.031494140625,
        -5122.98046875,
        1006.70703125
      ],
      [
        -3510.107177734375,
        -5120.31201171875,
        1003.70703125
      ],
      [
        -3506.913818359375,
        -5120.2626953125,
        1003.70703125
      ],
      [
        -3502.802001953125,
        -5122.86865234375,
        1006.70703125
      ],
      [
        -3497.5,
        -5123.205078125,
        1006.70703125
      ],
      [
        -3497.5,
        -5136.00048828125,
        1006.70703125
      ],
      [
        -3502.802001953125,
        -5122.86865234375,
        1006.70703125
      ],
      [
        -3497.5,
        -5064.00048828125,
        1006.70703125
      ],
      [
        -3514.114013671875,
        -5123.90673828125,
        1006.70703125
      ],
      [
        -3457.958251953125,
        -5104.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5096.00048828125,
        1001.70703125
      ],
      [
        -3443.0,
        -5096.00048828125,
        1001.70703125
      ],
      [
        -3443.0,
        -5096.00048828125,
        1003.70703125
      ],
      [
        -3441.75732421875,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3441.75732421875,
        -5084.00048828125,
        1001.70703125
      ],
      [
        -3362.0,
        -5095.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5095.00048828125,
        1001.70703125
      ],
      [
        -3362.0,
        -5084.00048828125,
        1003.70703125
      ],
      [
        -3362.0,
        -5084.00048828125,
        1001.70703125
      ],
      [
        -3443.0,
        -5103.00048828125,
        1001.70703125
      ],
      [
        -3443.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5103.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5103.00048828125,
        1001.70703125
      ],
      [
        -3468.0,
        -5080.00048828125,
        996.70703125
      ],
      [
        -3467.0,
        -5080.00048828125,
        996.70703125
      ],
      [
        -3468.0,
        -5080.00048828125,
        996.70703125
      ],
      [
        -3436.384765625,
        -5072.50048828125,
        982.3070068359375
      ],
      [
        -3489.415283203125,
        -5072.50048828125,
        982.3070068359375
      ],
      [
        -3436.06640625,
        -5072.56640625,
        982.2542114257812
      ],
      [
        -3436.384765625,
        -5072.50048828125,
        982.3070068359375
      ],
      [
        -3489.415283203125,
        -5072.50048828125,
        982.3070068359375
      ],
      [
        -3489.733642578125,
        -5072.56640625,
        982.2542114257812
      ],
      [
        -3435.09912109375,
        -5073.25048828125,
        981.7069702148438
      ],
      [
        -3436.06640625,
        -5072.56640625,
        982.2542114257812
      ],
      [
        -3490.700927734375,
        -5073.25048828125,
        981.7069702148438
      ],
      [
        -3489.733642578125,
        -5072.56640625,
        982.2542114257812
      ],
      [
        -3426.44140625,
        -5073.251953125,
        981.70556640625
      ],
      [
        -3426.300048828125,
        -5073.0732421875,
        981.848876953125
      ],
      [
        -3426.44140625,
        -5073.251953125,
        981.70556640625
      ],
      [
        -3425.5302734375,
        -5070.7490234375,
        981.70556640625
      ],
      [
        -3425.51318359375,
        -5071.0283203125,
        981.9293212890625
      ],
      [
        -3426.220947265625,
        -5072.97265625,
        981.9293212890625
      ],
      [
        -3421.962646484375,
        -5070.75341796875,
        981.7093505859375
      ],
      [
        -3422.71337890625,
        -5073.04833984375,
        981.86865234375
      ],
      [
        -3422.281494140625,
        -5072.50048828125,
        982.3070068359375
      ],
      [
        -3421.91748046875,
        -5071.50048828125,
        982.3070068359375
      ],
      [
        -3422.71337890625,
        -5073.04833984375,
        981.86865234375
      ],
      [
        -3426.003173828125,
        -5073.25146484375,
        981.7060546875
      ],
      [
        -3426.300048828125,
        -5073.0732421875,
        981.848876953125
      ],
      [
        -3422.55029296875,
        -5072.84130859375,
        982.0339965820312
      ],
      [
        -3422.59765625,
        -5072.82470703125,
        981.93310546875
      ],
      [
        -3422.64990234375,
        -5072.96826171875,
        981.93310546875
      ],
      [
        -3424.6416015625,
        -5072.970703125,
        981.9309692382812
      ],
      [
        -3425.896484375,
        -5073.01708984375,
        981.893798828125
      ],
      [
        -3425.0947265625,
        -5072.40576171875,
        982.3070068359375
      ],
      [
        -3425.129150390625,
        -5072.50048828125,
        982.3070068359375
      ],
      [
        -3425.17822265625,
        -5070.97607421875,
        981.8873291015625
      ],
      [
        -3424.772216796875,
        -5071.50048828125,
        982.3070068359375
      ],
      [
        -3425.0947265625,
        -5072.40576171875,
        982.3070068359375
      ],
      [
        -3425.136962890625,
        -5071.02880859375,
        981.9297485351562
      ],
      [
        -3421.94580078125,
        -5071.033203125,
        981.93310546875
      ],
      [
        -3425.82958984375,
        -5072.97216796875,
        981.9297485351562
      ],
      [
        -3426.220947265625,
        -5072.97265625,
        981.9293212890625
      ],
      [
        -3425.51318359375,
        -5071.0283203125,
        981.9293212890625
      ],
      [
        -3418.0,
        -5073.25048828125,
        981.70703125
      ],
      [
        -3418.0,
        -5070.75048828125,
        981.70703125
      ],
      [
        -3418.0,
        -5071.50048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5072.50048828125,
        982.3070068359375
      ],
      [
        -3421.88720703125,
        -5072.00048828125,
        982.70703125
      ],
      [
        -3424.4482421875,
        -5071.9189453125,
        982.6417236328125
      ],
      [
        -3424.386474609375,
        -5072.00048828125,
        982.7069091796875
      ],
      [
        -3424.4482421875,
        -5071.9189453125,
        982.6417236328125
      ],
      [
        -3418.0,
        -5072.00048828125,
        982.70703125
      ],
      [
        -3453.0,
        -5083.25,
        991.7069702148438
      ],
      [
        -3453.0,
        -5079.00048828125,
        988.30712890625
      ],
      [
        -3453.0,
        -5089.5,
        996.70703125
      ],
      [
        -3453.0,
        -5083.25,
        991.7069702148438
      ],
      [
        -3453.0,
        -5079.00048828125,
        988.3071899414062
      ],
      [
        -3453.0,
        -5089.5,
        996.70703125
      ],
      [
        -3418.0,
        -5075.75048828125,
        985.7069702148438
      ],
      [
        -3418.0,
        -5077.00048828125,
        986.7069702148438
      ],
      [
        -3418.0,
        -5075.75048828125,
        985.7069702148438
      ],
      [
        -3418.0,
        -5077.00048828125,
        986.7069702148438
      ],
      [
        -3418.0,
        -5079.00048828125,
        988.30712890625
      ],
      [
        -3418.0,
        -5079.00048828125,
        988.30712890625
      ],
      [
        -3418.0,
        -5083.25,
        991.7069702148438
      ],
      [
        -3418.0,
        -5083.25,
        991.7069702148438
      ],
      [
        -3418.0,
        -5089.5,
        996.70703125
      ],
      [
        -3421.8037109375,
        -5073.37939453125,
        983.8101806640625
      ],
      [
        -3425.3525390625,
        -5073.68408203125,
        984.0540161132812
      ],
      [
        -3425.3525390625,
        -5073.68408203125,
        984.0540161132812
      ],
      [
        -3425.369140625,
        -5073.412109375,
        983.8361206054688
      ],
      [
        -3421.8037109375,
        -5073.37939453125,
        983.8101806640625
      ],
      [
        -3421.9306640625,
        -5073.390625,
        983.8189086914062
      ],
      [
        -3421.810302734375,
        -5073.2705078125,
        983.7229614257812
      ],
      [
        -3425.369140625,
        -5073.412109375,
        983.8361206054688
      ],
      [
        -3421.820068359375,
        -5073.107421875,
        983.5925903320312
      ],
      [
        -3426.262451171875,
        -5073.08642578125,
        981.9293212890625
      ],
      [
        -3424.6416015625,
        -5072.970703125,
        981.9309692382812
      ],
      [
        -3423.42333984375,
        -5073.27099609375,
        983.7233276367188
      ],
      [
        -3424.353515625,
        -5073.17529296875,
        983.0352783203125
      ],
      [
        -3423.442138671875,
        -5073.24609375,
        983.70361328125
      ],
      [
        -3425.830078125,
        -5072.97216796875,
        981.9297485351562
      ],
      [
        -3425.861083984375,
        -5073.0576171875,
        981.9297485351562
      ],
      [
        -3489.800048828125,
        -5072.8857421875,
        982.3070068359375
      ],
      [
        -3489.800048828125,
        -5072.8857421875,
        982.3070068359375
      ],
      [
        -3491.55029296875,
        -5103.96240234375,
        981.70703125
      ],
      [
        -3489.314208984375,
        -5104.00048828125,
        981.7850341796875
      ],
      [
        -3491.493408203125,
        -5104.00048828125,
        981.7522583007812
      ],
      [
        -3489.272216796875,
        -5104.00048828125,
        981.783203125
      ],
      [
        -3489.314208984375,
        -5104.00048828125,
        981.7850341796875
      ],
      [
        -3489.272216796875,
        -5104.00048828125,
        981.783203125
      ],
      [
        -3489.050048828125,
        -5103.9892578125,
        981.70703125
      ],
      [
        -3489.079345703125,
        -5104.00048828125,
        981.7303466796875
      ],
      [
        -3468.0,
        -5079.00048828125,
        988.30712890625
      ],
      [
        -3453.0,
        -5079.00048828125,
        988.30712890625
      ],
      [
        -3453.0,
        -5079.00048828125,
        988.3071899414062
      ],
      [
        -3468.0,
        -5079.00048828125,
        988.3071899414062
      ],
      [
        -3467.0,
        -5080.00048828125,
        989.1072387695312
      ],
      [
        -3468.0,
        -5080.00048828125,
        989.1072387695312
      ],
      [
        -3468.0,
        -5080.00048828125,
        989.1072387695312
      ],
      [
        -3468.0,
        -5079.00048828125,
        988.3071899414062
      ],
      [
        -3458.230224609375,
        -5104.00048828125,
        982.5487060546875
      ],
      [
        -3457.039794921875,
        -5104.00048828125,
        982.5702514648438
      ],
      [
        -3463.319091796875,
        -5104.00048828125,
        982.1093139648438
      ],
      [
        -3464.839599609375,
        -5104.00048828125,
        981.70703125
      ],
      [
        -3458.230224609375,
        -5104.00048828125,
        982.5487060546875
      ],
      [
        -3462.85498046875,
        -5104.00048828125,
        981.9705200195312
      ],
      [
        -3462.85498046875,
        -5104.00048828125,
        981.9705200195312
      ],
      [
        -3463.319091796875,
        -5104.00048828125,
        982.1093139648438
      ],
      [
        -3488.994140625,
        -5104.00048828125,
        981.70703125
      ],
      [
        -3453.0,
        -5104.00048828125,
        982.8760375976562
      ],
      [
        -3457.039794921875,
        -5104.00048828125,
        982.5702514648438
      ],
      [
        -3423.736328125,
        -5067.09814453125,
        981.9296875
      ],
      [
        -3425.13720703125,
        -5071.02880859375,
        981.9296875
      ],
      [
        -3424.0341796875,
        -5067.046875,
        981.7057495117188
      ],
      [
        -3423.7822265625,
        -5067.2275390625,
        981.9296264648438
      ],
      [
        -3421.400634765625,
        -5069.53515625,
        981.93310546875
      ],
      [
        -3424.039306640625,
        -5066.978515625,
        981.9292602539062
      ],
      [
        -3424.166015625,
        -5073.85009765625,
        986.4039916992188
      ],
      [
        -3421.759033203125,
        -5073.1298828125,
        983.7229614257812
      ],
      [
        -3422.3798828125,
        -5073.32958984375,
        984.482666015625
      ],
      [
        -3422.43359375,
        -5073.37255859375,
        984.4555053710938
      ],
      [
        -3422.416748046875,
        -5073.32666015625,
        984.45556640625
      ],
      [
        -3423.442138671875,
        -5073.24609375,
        983.70361328125
      ],
      [
        -3420.788330078125,
        -5069.37548828125,
        984.5896606445312
      ],
      [
        -3423.7822265625,
        -5067.2275390625,
        981.9296264648438
      ],
      [
        -3420.854248046875,
        -5069.03173828125,
        984.4562377929688
      ],
      [
        -3420.939453125,
        -5069.26708984375,
        984.4554443359375
      ],
      [
        -3420.56201171875,
        -5069.8408203125,
        983.7229614257812
      ],
      [
        -3422.404296875,
        -5073.32275390625,
        984.441650390625
      ],
      [
        -3422.4169921875,
        -5073.32666015625,
        984.4556884765625
      ],
      [
        -3421.94287109375,
        -5067.74169921875,
        986.404052734375
      ],
      [
        -3420.939208984375,
        -5069.26708984375,
        984.4555053710938
      ],
      [
        -3361.0,
        -5151.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5152.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5114.20068359375,
        982.3070068359375
      ],
      [
        -3361.0,
        -5113.20068359375,
        982.3070068359375
      ],
      [
        -3356.066162109375,
        -5150.9345703125,
        982.2540893554688
      ],
      [
        -3356.0,
        -5150.615234375,
        982.3070068359375
      ],
      [
        -3356.0,
        -5114.5859375,
        982.3070068359375
      ],
      [
        -3356.066162109375,
        -5114.2666015625,
        982.2540893554688
      ],
      [
        -3356.749755859375,
        -5151.9013671875,
        981.7069702148438
      ],
      [
        -3356.066162109375,
        -5150.9345703125,
        982.2540893554688
      ],
      [
        -3356.749755859375,
        -5113.2998046875,
        981.7069702148438
      ],
      [
        -3356.066162109375,
        -5114.2666015625,
        982.2540893554688
      ],
      [
        -3356.75,
        -5166.00048828125,
        981.7069702148438
      ],
      [
        -3354.25,
        -5166.00048828125,
        981.7069702148438
      ],
      [
        -3355.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3356.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3354.25,
        -5166.00048828125,
        981.7069702148438
      ],
      [
        -3356.75,
        -5166.00048828125,
        981.7069702148438
      ],
      [
        -3356.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3355.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5166.00048828125,
        981.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5166.00048828125,
        981.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5114.95068359375,
        981.7069702148438
      ],
      [
        -3361.0,
        -5114.20068359375,
        982.3070068359375
      ],
      [
        -3361.0,
        -5113.20068359375,
        982.3070068359375
      ],
      [
        -3361.0,
        -5112.45068359375,
        981.7069702148438
      ],
      [
        -3358.600341796875,
        -5152.66796875,
        981.7069702148438
      ],
      [
        -3357.320068359375,
        -5151.3876953125,
        982.3070068359375
      ],
      [
        -3360.0,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3360.0,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3361.0,
        -5152.00048828125,
        982.3070068359375
      ],
      [
        -3359.999755859375,
        -5152.00048828125,
        982.3070068359375
      ],
      [
        -3360.2998046875,
        -5152.75048828125,
        981.7069702148438
      ],
      [
        -3361.0,
        -5152.75048828125,
        981.7069702148438
      ],
      [
        -3361.0,
        -5150.25048828125,
        981.7069702148438
      ],
      [
        -3360.2998046875,
        -5150.25048828125,
        981.7069702148438
      ],
      [
        -3359.999755859375,
        -5151.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5151.00048828125,
        982.3070068359375
      ],
      [
        -3360.25,
        -5151.00048828125,
        982.3070068359375
      ],
      [
        -3360.25,
        -5152.0009765625,
        982.3070068359375
      ],
      [
        -3360.39990234375,
        -5152.37548828125,
        982.0070190429688
      ],
      [
        -3360.39990234375,
        -5150.62548828125,
        982.0070190429688
      ],
      [
        -3361.0,
        -5150.25048828125,
        982.0070190429688
      ],
      [
        -3360.0,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3361.0,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3360.0,
        -5150.3505859375,
        982.3070068359375
      ],
      [
        -3361.0,
        -5150.50048828125,
        982.0070190429688
      ],
      [
        -3361.0,
        -5150.3505859375,
        982.3070068359375
      ],
      [
        -3360.25,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3360.25,
        -5150.35009765625,
        982.3070068359375
      ],
      [
        -3360.39990234375,
        -5150.50048828125,
        982.0070190429688
      ],
      [
        -3361.0,
        -5152.75048828125,
        982.0070190429688
      ],
      [
        -3361.0,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3360.0,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3360.0,
        -5152.650390625,
        982.3070068359375
      ],
      [
        -3361.0,
        -5152.650390625,
        982.3070068359375
      ],
      [
        -3361.0,
        -5152.50048828125,
        982.0070190429688
      ],
      [
        -3360.25,
        -5152.65087890625,
        982.3070068359375
      ],
      [
        -3360.25,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3360.39990234375,
        -5152.50048828125,
        982.0070190429688
      ],
      [
        -3361.0,
        -5166.00048828125,
        985.7069702148438
      ],
      [
        -3359.25,
        -5166.00048828125,
        985.7069702148438
      ],
      [
        -3360.499755859375,
        -5166.00048828125,
        986.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        986.7069702148438
      ],
      [
        -3359.25,
        -5166.00048828125,
        985.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        985.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        986.7069702148438
      ],
      [
        -3360.499755859375,
        -5166.00048828125,
        986.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        987.107177734375
      ],
      [
        -3361.0,
        -5166.00048828125,
        987.107177734375
      ],
      [
        -3361.0,
        -5148.75048828125,
        985.0070190429688
      ],
      [
        -3361.0,
        -5149.00048828125,
        985.0070190429688
      ],
      [
        -3361.0,
        -5154.25048828125,
        985.0070190429688
      ],
      [
        -3361.0,
        -5154.00048828125,
        985.0070190429688
      ],
      [
        -3361.0,
        -5148.75048828125,
        985.0070190429688
      ],
      [
        -3361.0,
        -5154.25048828125,
        985.0070190429688
      ],
      [
        -3361.0,
        -5154.00048828125,
        985.0070190429688
      ],
      [
        -3358.89990234375,
        -5154.00048828125,
        985.0070190429688
      ],
      [
        -3360.25,
        -5152.65087890625,
        982.3070068359375
      ],
      [
        -3360.0,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3360.0498046875,
        -5152.900390625,
        982.70703125
      ],
      [
        -3360.0498046875,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3361.0,
        -5152.900390625,
        982.70703125
      ],
      [
        -3361.0,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3358.899658203125,
        -5149.00048828125,
        985.0070190429688
      ],
      [
        -3360.249755859375,
        -5150.3505859375,
        982.3070068359375
      ],
      [
        -3360.0498046875,
        -5150.1005859375,
        982.70703125
      ],
      [
        -3360.0,
        -5150.150390625,
        982.70703125
      ],
      [
        -3360.0498046875,
        -5150.150390625,
        982.70703125
      ],
      [
        -3360.0498046875,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3361.0,
        -5149.00048828125,
        985.0070190429688
      ],
      [
        -3361.0,
        -5150.1005859375,
        982.70703125
      ],
      [
        -3360.0498046875,
        -5150.150390625,
        982.70703125
      ],
      [
        -3361.0,
        -5150.150390625,
        982.70703125
      ],
      [
        -3361.0,
        -5166.00048828125,
        991.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        996.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        991.7069702148438
      ],
      [
        -3361.0,
        -5166.00048828125,
        996.7069702148438
      ],
      [
        -3453.0,
        -5221.00048828125,
        981.7069702148438
      ],
      [
        -3453.0,
        -5236.00048828125,
        996.7069702148438
      ],
      [
        -3453.0,
        -5221.00048828125,
        996.7069702148438
      ],
      [
        -3479.220947265625,
        -5221.00048828125,
        988.12109375
      ],
      [
        -3474.642333984375,
        -5221.00048828125,
        992.828369140625
      ],
      [
        -3483.0361328125,
        -5221.00048828125,
        983.084716796875
      ],
      [
        -3479.220947265625,
        -5221.00048828125,
        988.12109375
      ],
      [
        -3472.4873046875,
        -5221.00048828125,
        994.6514892578125
      ],
      [
        -3474.642333984375,
        -5221.00048828125,
        992.828369140625
      ],
      [
        -3483.66650390625,
        -5221.00048828125,
        982.1767578125
      ],
      [
        -3483.0361328125,
        -5221.00048828125,
        983.084716796875
      ],
      [
        -3484.06396484375,
        -5221.00048828125,
        981.70703125
      ],
      [
        -3483.66650390625,
        -5221.00048828125,
        982.1767578125
      ],
      [
        -3472.4873046875,
        -5221.00048828125,
        994.6514892578125
      ],
      [
        -3472.201904296875,
        -5221.00048828125,
        995.336669921875
      ],
      [
        -3472.069580078125,
        -5223.74951171875,
        996.7069702148438
      ],
      [
        -3472.691162109375,
        -5230.17138671875,
        996.7069702148438
      ],
      [
        -3471.2900390625,
        -5236.00048828125,
        996.7069702148438
      ],
      [
        -3472.691162109375,
        -5230.17138671875,
        996.7069702148438
      ],
      [
        -3472.069580078125,
        -5223.74951171875,
        996.7069702148438
      ],
      [
        -3471.630859375,
        -5221.00048828125,
        996.7069702148438
      ],
      [
        -3394.244140625,
        -5231.0,
        991.4669799804688
      ],
      [
        -3394.243896484375,
        -5236.00048828125,
        991.4669189453125
      ],
      [
        -3394.244140625,
        -5231.0,
        991.4669799804688
      ],
      [
        -3399.606201171875,
        -5236.00048828125,
        996.7069702148438
      ],
      [
        -3399.606201171875,
        -5231.0,
        996.7069702148438
      ],
      [
        -3436.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3436.75,
        -5221.00048828125,
        981.7069702148438
      ],
      [
        -3435.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3436.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3434.933837890625,
        -5227.9345703125,
        982.2540893554688
      ],
      [
        -3434.6142578125,
        -5228.00048828125,
        982.3070068359375
      ],
      [
        -3411.585693359375,
        -5228.00048828125,
        982.3070068359375
      ],
      [
        -3411.26611328125,
        -5227.9345703125,
        982.2540893554688
      ],
      [
        -3421.75,
        -5228.00048828125,
        982.3070068359375
      ],
      [
        -3421.75,
        -5229.00048828125,
        982.3070068359375
      ],
      [
        -3421.89990234375,
        -5229.37548828125,
        982.0070190429688
      ],
      [
        -3421.89990234375,
        -5227.62548828125,
        982.0070190429688
      ],
      [
        -3421.64990234375,
        -5227.62548828125,
        982.0070190429688
      ],
      [
        -3421.64990234375,
        -5229.37548828125,
        982.0070190429688
      ],
      [
        -3421.5,
        -5229.00048828125,
        982.3070068359375
      ],
      [
        -3421.5,
        -5228.00048828125,
        982.3070068359375
      ],
      [
        -3425.64990234375,
        -5229.37548828125,
        982.0070190429688
      ],
      [
        -3425.64990234375,
        -5227.62548828125,
        982.0070190429688
      ],
      [
        -3425.7998046875,
        -5228.00048828125,
        982.3070068359375
      ],
      [
        -3425.7998046875,
        -5229.00048828125,
        982.3070068359375
      ],
      [
        -3425.39990234375,
        -5227.62548828125,
        982.0070190429688
      ],
      [
        -3425.39990234375,
        -5229.37548828125,
        982.0070190429688
      ],
      [
        -3425.5498046875,
        -5229.00048828125,
        982.3070068359375
      ],
      [
        -3425.5498046875,
        -5228.00048828125,
        982.3070068359375
      ],
      [
        -3434.25,
        -5221.00048828125,
        981.7069702148438
      ],
      [
        -3435.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3421.5,
        -5227.1005859375,
        982.3070068359375
      ],
      [
        -3425.7998046875,
        -5227.1005859375,
        982.3070068359375
      ],
      [
        -3425.7998046875,
        -5227.1005859375,
        982.3070068359375
      ],
      [
        -3421.5,
        -5227.1005859375,
        982.3070068359375
      ],
      [
        -3421.75,
        -5227.1005859375,
        982.3070068359375
      ],
      [
        -3421.749755859375,
        -5227.3505859375,
        982.3070068359375
      ],
      [
        -3421.5,
        -5227.3505859375,
        982.3070068359375
      ],
      [
        -3421.89990234375,
        -5227.50048828125,
        982.0070190429688
      ],
      [
        -3425.7998046875,
        -5227.3505859375,
        982.3070068359375
      ],
      [
        -3425.5498046875,
        -5227.1005859375,
        982.3070068359375
      ],
      [
        -3425.39990234375,
        -5227.50048828125,
        982.0070190429688
      ],
      [
        -3425.5498046875,
        -5227.3505859375,
        982.3070068359375
      ],
      [
        -3420.233154296875,
        -5225.83349609375,
        984.8407592773438
      ],
      [
        -3427.066650390625,
        -5225.83349609375,
        984.8407592773438
      ],
      [
        -3427.066650390625,
        -5225.83349609375,
        984.8407592773438
      ],
      [
        -3420.233154296875,
        -5225.83349609375,
        984.8407592773438
      ],
      [
        -3420.483154296875,
        -5225.83349609375,
        984.8407592773438
      ],
      [
        -3420.649658203125,
        -5226.25048828125,
        984.5072631835938
      ],
      [
        -3420.399658203125,
        -5226.25048828125,
        984.5072631835938
      ],
      [
        -3421.749755859375,
        -5227.3505859375,
        982.3070068359375
      ],
      [
        -3421.549560546875,
        -5227.1005859375,
        982.70703125
      ],
      [
        -3421.5,
        -5227.15087890625,
        982.70703125
      ],
      [
        -3421.549560546875,
        -5227.15087890625,
        982.70703125
      ],
      [
        -3421.5,
        -5228.50048828125,
        982.70703125
      ],
      [
        -3421.549560546875,
        -5228.50048828125,
        982.70703125
      ],
      [
        -3426.900146484375,
        -5226.25048828125,
        984.5072631835938
      ],
      [
        -3425.800048828125,
        -5227.15087890625,
        982.70703125
      ],
      [
        -3421.549560546875,
        -5227.15087890625,
        982.70703125
      ],
      [
        -3425.749755859375,
        -5226.900390625,
        982.70703125
      ],
      [
        -3425.5498046875,
        -5227.3505859375,
        982.3070068359375
      ],
      [
        -3425.749755859375,
        -5227.150390625,
        982.70703125
      ],
      [
        -3426.816650390625,
        -5225.83349609375,
        984.8407592773438
      ],
      [
        -3426.649658203125,
        -5226.2509765625,
        984.5066528320312
      ],
      [
        -3425.800048828125,
        -5228.50048828125,
        982.70703125
      ],
      [
        -3425.749755859375,
        -5228.50048828125,
        982.70703125
      ],
      [
        -3425.749755859375,
        -5227.150390625,
        982.70703125
      ],
      [
        -3420.39990234375,
        -5226.0009765625,
        985.0070190429688
      ],
      [
        -3420.650146484375,
        -5226.2509765625,
        984.5066528320312
      ],
      [
        -3426.89990234375,
        -5226.0009765625,
        985.0070190429688
      ],
      [
        -3426.649658203125,
        -5226.2509765625,
        984.5066528320312
      ],
      [
        -3420.39990234375,
        -5231.00048828125,
        985.0070190429688
      ],
      [
        -3421.89990234375,
        -5229.50048828125,
        982.0070190429688
      ],
      [
        -3421.5,
        -5229.85009765625,
        982.70703125
      ],
      [
        -3421.549560546875,
        -5229.900390625,
        982.70703125
      ],
      [
        -3421.549560546875,
        -5229.85009765625,
        982.70703125
      ],
      [
        -3421.549560546875,
        -5228.50048828125,
        982.70703125
      ],
      [
        -3425.800048828125,
        -5229.85009765625,
        982.70703125
      ],
      [
        -3421.549560546875,
        -5229.85009765625,
        982.70703125
      ],
      [
        -3425.75,
        -5230.1005859375,
        982.70703125
      ],
      [
        -3425.75,
        -5229.8505859375,
        982.70703125
      ],
      [
        -3425.39990234375,
        -5229.50048828125,
        982.0070190429688
      ],
      [
        -3426.89990234375,
        -5231.0,
        985.0070190429688
      ],
      [
        -3425.75,
        -5228.50048828125,
        982.70703125
      ],
      [
        -3425.75,
        -5229.85009765625,
        982.70703125
      ],
      [
        -3399.606201171875,
        -5231.0,
        996.7069702148438
      ],
      [
        -3400.171875,
        -5231.0,
        996.7069702148438
      ],
      [
        -3400.171875,
        -5231.0,
        996.7069702148438
      ],
      [
        -3400.171875,
        -5236.0,
        996.7069702148438
      ],
      [
        -3399.6064453125,
        -5231.00048828125,
        996.20703125
      ],
      [
        -3399.6064453125,
        -5236.00048828125,
        996.20703125
      ],
      [
        -3398.949951171875,
        -5231.00048828125,
        995.6268310546875
      ],
      [
        -3398.949951171875,
        -5236.00048828125,
        995.6268310546875
      ],
      [
        -3413.5,
        -5221.00048828125,
        989.70703125
      ],
      [
        -3407.5,
        -5221.00048828125,
        989.70703125
      ],
      [
        -3413.5,
        -5221.00048828125,
        985.70703125
      ],
      [
        -3407.5,
        -5221.00048828125,
        985.70703125
      ],
      [
        -3413.5,
        -5221.00048828125,
        985.70703125
      ],
      [
        -3413.5,
        -5221.00048828125,
        989.70703125
      ],
      [
        -3407.5,
        -5221.00048828125,
        989.70703125
      ],
      [
        -3407.5,
        -5221.00048828125,
        985.70703125
      ],
      [
        -3407.800048828125,
        -5221.00048828125,
        989.4070434570312
      ],
      [
        -3413.199951171875,
        -5221.00048828125,
        989.4070434570312
      ],
      [
        -3407.800048828125,
        -5221.00048828125,
        986.0070190429688
      ],
      [
        -3407.800048828125,
        -5221.00048828125,
        989.4070434570312
      ],
      [
        -3413.199951171875,
        -5221.00048828125,
        989.4070434570312
      ],
      [
        -3413.199951171875,
        -5221.00048828125,
        986.0070190429688
      ],
      [
        -3514.933837890625,
        -5150.56640625,
        982.2540893554688
      ],
      [
        -3515.0,
        -5150.8857421875,
        982.3070068359375
      ],
      [
        -3515.0,
        -5198.9150390625,
        982.3070068359375
      ],
      [
        -3514.933837890625,
        -5199.234375,
        982.2540893554688
      ],
      [
        -3514.250244140625,
        -5149.599609375,
        981.7069702148438
      ],
      [
        -3514.933837890625,
        -5150.56640625,
        982.2540893554688
      ],
      [
        -3514.250244140625,
        -5200.201171875,
        981.7069702148438
      ],
      [
        -3514.933837890625,
        -5199.234375,
        982.2540893554688
      ],
      [
        -3514.250244140625,
        -5136.00048828125,
        981.7069702148438
      ],
      [
        -3516.750244140625,
        -5136.00048828125,
        981.7069702148438
      ],
      [
        -3516.000244140625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3515.000244140625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3516.750244140625,
        -5105.751953125,
        981.70703125
      ],
      [
        -3515.013671875,
        -5106.20849609375,
        982.3070068359375
      ],
      [
        -3516.0,
        -5106.24755859375,
        982.3070068359375
      ],
      [
        -3514.770263671875,
        -5105.9384765625,
        982.1229858398438
      ],
      [
        -3514.250244140625,
        -5105.58642578125,
        981.70703125
      ],
      [
        -3514.770263671875,
        -5105.9384765625,
        982.1229858398438
      ],
      [
        -3515.0,
        -5106.20361328125,
        982.3070068359375
      ],
      [
        -3515.013671875,
        -5106.20849609375,
        982.3070068359375
      ],
      [
        -3523.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3522.35546875,
        -5106.5,
        982.3070068359375
      ],
      [
        -3522.35546875,
        -5106.5,
        982.3070068359375
      ],
      [
        -3523.0,
        -5106.49072265625,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3428.0,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3428.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3453.0,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3443.0,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3443.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3433.5,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3437.60009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3433.5,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3437.60009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5166.400390625,
        982.3070068359375
      ],
      [
        -3432.0,
        -5166.400390625,
        982.3070068359375
      ],
      [
        -3431.0,
        -5166.400390625,
        982.3070068359375
      ],
      [
        -3431.0,
        -5166.400390625,
        982.3070068359375
      ],
      [
        -3431.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5166.400390625,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5166.400390625,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5166.400390625,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3431.0,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3432.0,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3432.0,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3432.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3431.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3431.0,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5165.6005859375,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3431.0,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3431.0,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3431.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5136.400390625,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3431.10009765625,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3439.89990234375,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3431.10009765625,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3431.10009765625,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3439.89990234375,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3439.89990234375,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3433.5,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3437.60009765625,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3433.5,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3437.60009765625,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5104.50048828125,
        981.70703125
      ],
      [
        -3438.89990234375,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5104.50048828125,
        981.70703125
      ],
      [
        -3438.89990234375,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5105.00048828125,
        982.3070068359375
      ],
      [
        -3432.0,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3432.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3431.0,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3432.0,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3431.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3431.0,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3439.10009765625,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5135.6005859375,
        982.3070068359375
      ],
      [
        -3440.10009765625,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5135.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5135.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5135.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5106.0009765625,
        982.3070068359375
      ],
      [
        -3453.0,
        -5106.0009765625,
        982.3070068359375
      ],
      [
        -3443.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5167.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5167.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5167.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3452.5,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3508.42333984375,
        -5105.39306640625,
        982.3070068359375
      ],
      [
        -3514.5625,
        -5106.04736328125,
        982.3070068359375
      ],
      [
        -3501.392822265625,
        -5104.88134765625,
        982.3070068359375
      ],
      [
        -3507.7919921875,
        -5105.42626953125,
        982.3070068359375
      ],
      [
        -3494.108154296875,
        -5104.5068359375,
        982.3070068359375
      ],
      [
        -3501.04931640625,
        -5104.89794921875,
        982.3070068359375
      ],
      [
        -3468.405517578125,
        -5106.8623046875,
        982.3070068359375
      ],
      [
        -3472.630126953125,
        -5107.576171875,
        982.3070068359375
      ],
      [
        -3473.489013671875,
        -5106.490234375,
        982.3070068359375
      ],
      [
        -3478.397705078125,
        -5105.845703125,
        982.3070068359375
      ],
      [
        -3478.87109375,
        -5105.88916015625,
        982.3070068359375
      ],
      [
        -3483.739990234375,
        -5105.60107421875,
        982.3070068359375
      ],
      [
        -3472.630126953125,
        -5107.576171875,
        982.3070068359375
      ],
      [
        -3473.489013671875,
        -5106.490234375,
        982.3070068359375
      ],
      [
        -3514.5625,
        -5106.04736328125,
        982.3070068359375
      ],
      [
        -3483.926513671875,
        -5105.462890625,
        982.3070068359375
      ],
      [
        -3488.91748046875,
        -5104.45703125,
        982.3070068359375
      ],
      [
        -3489.2509765625,
        -5104.44482421875,
        982.3070068359375
      ],
      [
        -3494.108154296875,
        -5104.5068359375,
        982.3070068359375
      ],
      [
        -3483.739990234375,
        -5105.60107421875,
        982.3070068359375
      ],
      [
        -3483.926513671875,
        -5105.462890625,
        982.3070068359375
      ],
      [
        -3488.91748046875,
        -5104.45703125,
        982.3070068359375
      ],
      [
        -3489.2509765625,
        -5104.44482421875,
        982.3070068359375
      ],
      [
        -3478.87109375,
        -5105.88916015625,
        982.3070068359375
      ],
      [
        -3478.397705078125,
        -5105.845703125,
        982.3070068359375
      ],
      [
        -3463.33837890625,
        -5104.24609375,
        982.3070068359375
      ],
      [
        -3467.954345703125,
        -5105.72607421875,
        982.3070068359375
      ],
      [
        -3467.954345703125,
        -5105.72607421875,
        982.3070068359375
      ],
      [
        -3468.405517578125,
        -5106.8623046875,
        982.3070068359375
      ],
      [
        -3462.312255859375,
        -5104.63916015625,
        982.3070068359375
      ],
      [
        -3460.16357421875,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3462.312255859375,
        -5104.63916015625,
        982.3070068359375
      ],
      [
        -3463.33837890625,
        -5104.24609375,
        982.3070068359375
      ],
      [
        -3501.392822265625,
        -5104.88134765625,
        982.3070068359375
      ],
      [
        -3501.04931640625,
        -5104.89794921875,
        982.3070068359375
      ],
      [
        -3507.7919921875,
        -5105.42626953125,
        982.3070068359375
      ],
      [
        -3508.42333984375,
        -5105.39306640625,
        982.3070068359375
      ],
      [
        -3508.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5178.00048828125,
        981.7069702148438
      ],
      [
        -3508.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5178.00048828125,
        981.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3484.5087890625,
        -5176.38037109375,
        982.3070068359375
      ],
      [
        -3483.989501953125,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3484.948486328125,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3485.560546875,
        -5171.27685546875,
        982.3070068359375
      ],
      [
        -3484.361328125,
        -5175.31298828125,
        982.3070068359375
      ],
      [
        -3486.460205078125,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3485.59521484375,
        -5170.4521484375,
        982.3070068359375
      ],
      [
        -3485.560546875,
        -5171.27685546875,
        982.3070068359375
      ],
      [
        -3485.59521484375,
        -5170.4521484375,
        982.3070068359375
      ],
      [
        -3484.361328125,
        -5175.31298828125,
        982.3070068359375
      ],
      [
        -3484.5087890625,
        -5176.38037109375,
        982.3070068359375
      ],
      [
        -3453.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3454.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3454.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3454.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5156.00048828125,
        981.70703125
      ],
      [
        -3472.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5156.00048828125,
        981.70703125
      ],
      [
        -3474.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3493.72607421875,
        -5157.06689453125,
        982.3070068359375
      ],
      [
        -3492.709228515625,
        -5158.58837890625,
        982.3070068359375
      ],
      [
        -3493.374755859375,
        -5159.25390625,
        982.3070068359375
      ],
      [
        -3494.595458984375,
        -5157.42724609375,
        982.3070068359375
      ],
      [
        -3492.709228515625,
        -5158.58837890625,
        982.3070068359375
      ],
      [
        -3493.374755859375,
        -5159.25390625,
        982.3070068359375
      ],
      [
        -3494.595458984375,
        -5157.42724609375,
        982.3070068359375
      ],
      [
        -3493.72607421875,
        -5157.06689453125,
        982.3070068359375
      ],
      [
        -3484.5,
        -5164.1728515625,
        982.3070068359375
      ],
      [
        -3486.655029296875,
        -5163.744140625,
        982.3070068359375
      ],
      [
        -3486.294677734375,
        -5162.87451171875,
        982.3070068359375
      ],
      [
        -3484.5,
        -5163.2314453125,
        982.3070068359375
      ],
      [
        -3484.5,
        -5163.2314453125,
        982.3070068359375
      ],
      [
        -3484.5,
        -5164.1728515625,
        982.3070068359375
      ],
      [
        -3486.655029296875,
        -5163.744140625,
        982.3070068359375
      ],
      [
        -3486.294677734375,
        -5162.87451171875,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3454.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3454.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3454.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5146.00048828125,
        981.70703125
      ],
      [
        -3472.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5146.00048828125,
        981.70703125
      ],
      [
        -3474.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3491.25341796875,
        -5140.62548828125,
        982.3070068359375
      ],
      [
        -3489.4267578125,
        -5139.40478515625,
        982.3070068359375
      ],
      [
        -3489.06640625,
        -5140.2744140625,
        982.3070068359375
      ],
      [
        -3490.587890625,
        -5141.291015625,
        982.3070068359375
      ],
      [
        -3489.4267578125,
        -5139.40478515625,
        982.3070068359375
      ],
      [
        -3489.06640625,
        -5140.2744140625,
        982.3070068359375
      ],
      [
        -3490.587890625,
        -5141.291015625,
        982.3070068359375
      ],
      [
        -3491.25341796875,
        -5140.62548828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.94189453125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3496.17236328125,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3495.74365234375,
        -5147.345703125,
        982.3070068359375
      ],
      [
        -3494.8740234375,
        -5147.70556640625,
        982.3070068359375
      ],
      [
        -3495.23095703125,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3495.23095703125,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3496.17236328125,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3495.74365234375,
        -5147.345703125,
        982.3070068359375
      ],
      [
        -3494.8740234375,
        -5147.70556640625,
        982.3070068359375
      ],
      [
        -3453.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3482.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3482.0,
        -5146.94189453125,
        982.3070068359375
      ],
      [
        -3482.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5146.94189453125,
        982.3070068359375
      ],
      [
        -3482.0,
        -5146.94189453125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3472.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3482.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3483.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3482.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3482.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3453.5,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3418.0,
        -5178.00048828125,
        981.70703125
      ],
      [
        -3418.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5119.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5120.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5114.95068359375,
        981.7069702148438
      ],
      [
        -3363.0,
        -5114.20068359375,
        982.3070068359375
      ],
      [
        -3363.0,
        -5113.20068359375,
        982.3070068359375
      ],
      [
        -3363.0,
        -5112.45068359375,
        981.7069702148438
      ],
      [
        -3387.885986328125,
        -5114.20068359375,
        982.3070068359375
      ],
      [
        -3387.992431640625,
        -5113.20068359375,
        982.3070068359375
      ],
      [
        -3387.617919921875,
        -5112.45068359375,
        981.70703125
      ],
      [
        -3387.3515625,
        -5114.95068359375,
        981.70703125
      ],
      [
        -3380.78564453125,
        -5114.91650390625,
        981.7343139648438
      ],
      [
        -3381.064208984375,
        -5112.45654296875,
        981.7114868164062
      ],
      [
        -3380.753173828125,
        -5112.45068359375,
        981.70703125
      ],
      [
        -3378.838134765625,
        -5114.95068359375,
        981.70703125
      ],
      [
        -3388.07373046875,
        -5112.43798828125,
        982.3070068359375
      ],
      [
        -3388.09814453125,
        -5111.93896484375,
        982.3070068359375
      ],
      [
        -3388.09814453125,
        -5111.93896484375,
        982.3070068359375
      ],
      [
        -3388.3935546875,
        -5104.50830078125,
        982.3070068359375
      ],
      [
        -3388.3935546875,
        -5104.50830078125,
        982.3070068359375
      ],
      [
        -3388.490234375,
        -5104.00048828125,
        982.3070068359375
      ],
      [
        -3388.07373046875,
        -5112.43798828125,
        982.3070068359375
      ],
      [
        -3386.506591796875,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3386.89697265625,
        -5125.77490234375,
        982.3070068359375
      ],
      [
        -3387.419677734375,
        -5118.5771484375,
        982.3070068359375
      ],
      [
        -3386.90625,
        -5125.52392578125,
        982.3070068359375
      ],
      [
        -3387.426025390625,
        -5119.42431640625,
        982.3070068359375
      ],
      [
        -3387.426025390625,
        -5119.42431640625,
        982.3070068359375
      ],
      [
        -3387.419677734375,
        -5118.5771484375,
        982.3070068359375
      ],
      [
        -3364.0,
        -5119.00048828125,
        982.3070068359375
      ],
      [
        -3364.0,
        -5120.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5119.00048828125,
        982.3070068359375
      ],
      [
        -3364.0,
        -5119.00048828125,
        982.3070068359375
      ],
      [
        -3364.0,
        -5120.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5120.00048828125,
        982.3070068359375
      ],
      [
        -3386.880859375,
        -5125.8232421875,
        982.3070068359375
      ],
      [
        -3361.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3363.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3417.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3417.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3417.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5162.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5156.00048828125,
        981.70703125
      ],
      [
        -3399.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5156.00048828125,
        981.70703125
      ],
      [
        -3397.0,
        -5156.50048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3378.290771484375,
        -5158.58837890625,
        982.3070068359375
      ],
      [
        -3377.27392578125,
        -5157.06689453125,
        982.3070068359375
      ],
      [
        -3376.404541015625,
        -5157.42724609375,
        982.3070068359375
      ],
      [
        -3377.625244140625,
        -5159.25390625,
        982.3070068359375
      ],
      [
        -3377.625244140625,
        -5159.25390625,
        982.3070068359375
      ],
      [
        -3378.290771484375,
        -5158.58837890625,
        982.3070068359375
      ],
      [
        -3377.27392578125,
        -5157.06689453125,
        982.3070068359375
      ],
      [
        -3376.404541015625,
        -5157.42724609375,
        982.3070068359375
      ],
      [
        -3384.344970703125,
        -5163.744140625,
        982.3070068359375
      ],
      [
        -3386.5,
        -5164.1728515625,
        982.3070068359375
      ],
      [
        -3386.5,
        -5163.2314453125,
        982.3070068359375
      ],
      [
        -3384.705322265625,
        -5162.87451171875,
        982.3070068359375
      ],
      [
        -3386.5,
        -5164.1728515625,
        982.3070068359375
      ],
      [
        -3386.5,
        -5163.2314453125,
        982.3070068359375
      ],
      [
        -3384.705322265625,
        -5162.87451171875,
        982.3070068359375
      ],
      [
        -3384.344970703125,
        -5163.744140625,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3417.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3417.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3417.0,
        -5140.00048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5146.00048828125,
        981.70703125
      ],
      [
        -3399.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5145.50048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5146.00048828125,
        981.70703125
      ],
      [
        -3397.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3381.5732421875,
        -5139.40478515625,
        982.3070068359375
      ],
      [
        -3379.74658203125,
        -5140.62548828125,
        982.3070068359375
      ],
      [
        -3380.412109375,
        -5141.291015625,
        982.3070068359375
      ],
      [
        -3381.93359375,
        -5140.2744140625,
        982.3070068359375
      ],
      [
        -3381.93359375,
        -5140.2744140625,
        982.3070068359375
      ],
      [
        -3381.5732421875,
        -5139.40478515625,
        982.3070068359375
      ],
      [
        -3379.74658203125,
        -5140.62548828125,
        982.3070068359375
      ],
      [
        -3380.412109375,
        -5141.291015625,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3361.0,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3364.2998046875,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3364.2998046875,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3361.0,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3365.857177734375,
        -5152.64306640625,
        981.792724609375
      ],
      [
        -3361.0,
        -5152.64306640625,
        981.792724609375
      ],
      [
        -3364.14990234375,
        -5152.37548828125,
        982.0070190429688
      ],
      [
        -3364.2998046875,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3364.2998046875,
        -5152.0009765625,
        982.3070068359375
      ],
      [
        -3364.04296875,
        -5150.35791015625,
        981.792724609375
      ],
      [
        -3361.0,
        -5150.35791015625,
        981.792724609375
      ],
      [
        -3364.2998046875,
        -5151.00048828125,
        982.3070068359375
      ],
      [
        -3364.0498046875,
        -5152.0009765625,
        982.3070068359375
      ],
      [
        -3364.0498046875,
        -5151.00048828125,
        982.3070068359375
      ],
      [
        -3363.89990234375,
        -5150.62548828125,
        982.0070190429688
      ],
      [
        -3363.89990234375,
        -5152.37548828125,
        982.0070190429688
      ],
      [
        -3364.2998046875,
        -5150.3505859375,
        982.3070068359375
      ],
      [
        -3361.0,
        -5150.3505859375,
        982.3070068359375
      ],
      [
        -3364.0498046875,
        -5150.35009765625,
        982.3070068359375
      ],
      [
        -3364.0498046875,
        -5150.1005859375,
        982.3070068359375
      ],
      [
        -3363.89990234375,
        -5150.50048828125,
        982.0070190429688
      ],
      [
        -3365.857177734375,
        -5150.35791015625,
        981.792724609375
      ],
      [
        -3364.2998046875,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3364.2998046875,
        -5152.650390625,
        982.3070068359375
      ],
      [
        -3361.0,
        -5152.650390625,
        982.3070068359375
      ],
      [
        -3364.0498046875,
        -5152.900390625,
        982.3070068359375
      ],
      [
        -3364.0498046875,
        -5152.65087890625,
        982.3070068359375
      ],
      [
        -3363.89990234375,
        -5152.50048828125,
        982.0070190429688
      ],
      [
        -3375.25634765625,
        -5147.345703125,
        982.3070068359375
      ],
      [
        -3374.82763671875,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3375.76904296875,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3376.1259765625,
        -5147.70556640625,
        982.3070068359375
      ],
      [
        -3374.82763671875,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3375.76904296875,
        -5149.50048828125,
        982.3070068359375
      ],
      [
        -3376.1259765625,
        -5147.70556640625,
        982.3070068359375
      ],
      [
        -3375.25634765625,
        -5147.345703125,
        982.3070068359375
      ],
      [
        -3417.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3417.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3417.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3417.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3389.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3389.0,
        -5146.94189453125,
        982.3070068359375
      ],
      [
        -3389.0,
        -5147.94189453125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3399.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3389.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3389.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3389.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3388.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3417.5,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3417.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3417.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5135.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5135.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5135.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5136.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5106.0009765625,
        982.3070068359375
      ],
      [
        -3422.0,
        -5106.0009765625,
        982.3070068359375
      ],
      [
        -3418.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5167.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5167.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5166.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5167.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5148.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5147.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5154.00048828125,
        982.3070068359375
      ],
      [
        -3418.5,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5155.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5217.25048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5217.25048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3391.826904296875,
        -5207.53857421875,
        982.3070068359375
      ],
      [
        -3388.948486328125,
        -5200.58984375,
        982.3070068359375
      ],
      [
        -3382.0,
        -5197.7119140625,
        982.3070068359375
      ],
      [
        -3375.051513671875,
        -5200.58984375,
        982.3070068359375
      ],
      [
        -3375.051513671875,
        -5200.58984375,
        982.3070068359375
      ],
      [
        -3372.173095703125,
        -5207.53857421875,
        982.3070068359375
      ],
      [
        -3375.051513671875,
        -5214.48681640625,
        982.3070068359375
      ],
      [
        -3382.0,
        -5217.365234375,
        982.3070068359375
      ],
      [
        -3382.0,
        -5217.365234375,
        982.3070068359375
      ],
      [
        -3388.948486328125,
        -5214.48681640625,
        982.3070068359375
      ],
      [
        -3388.948486328125,
        -5200.58984375,
        982.3070068359375
      ],
      [
        -3382.0,
        -5197.7119140625,
        982.3070068359375
      ],
      [
        -3388.948486328125,
        -5214.48681640625,
        982.3070068359375
      ],
      [
        -3391.826904296875,
        -5207.53857421875,
        982.3070068359375
      ],
      [
        -3372.173095703125,
        -5207.53857421875,
        982.3070068359375
      ],
      [
        -3375.051513671875,
        -5214.48681640625,
        982.3070068359375
      ],
      [
        -3377.53515625,
        -5194.53564453125,
        982.3070068359375
      ],
      [
        -3379.620849609375,
        -5189.50048828125,
        982.3070068359375
      ],
      [
        -3367.46484375,
        -5184.46533203125,
        982.3070068359375
      ],
      [
        -3365.379150390625,
        -5189.50048828125,
        982.3070068359375
      ],
      [
        -3365.379150390625,
        -5189.50048828125,
        982.3070068359375
      ],
      [
        -3367.46484375,
        -5194.53564453125,
        982.3070068359375
      ],
      [
        -3379.620849609375,
        -5189.50048828125,
        982.3070068359375
      ],
      [
        -3377.53515625,
        -5184.46533203125,
        982.3070068359375
      ],
      [
        -3367.46484375,
        -5194.53564453125,
        982.3070068359375
      ],
      [
        -3372.5,
        -5196.62109375,
        982.3070068359375
      ],
      [
        -3372.5,
        -5196.62109375,
        982.3070068359375
      ],
      [
        -3377.53515625,
        -5194.53564453125,
        982.3070068359375
      ],
      [
        -3377.53515625,
        -5184.46533203125,
        982.3070068359375
      ],
      [
        -3372.5,
        -5182.3798828125,
        982.3070068359375
      ],
      [
        -3372.5,
        -5182.3798828125,
        982.3070068359375
      ],
      [
        -3367.46484375,
        -5184.46533203125,
        982.3070068359375
      ],
      [
        -3396.5,
        -5207.00048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3396.5,
        -5204.50048828125,
        982.3070068359375
      ],
      [
        -3396.5,
        -5207.00048828125,
        982.3070068359375
      ],
      [
        -3396.5,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3396.5,
        -5193.50048828125,
        982.3070068359375
      ],
      [
        -3396.5,
        -5193.50048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5193.50048828125,
        981.70703125
      ],
      [
        -3398.699951171875,
        -5193.50048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5191.00048828125,
        981.70703125
      ],
      [
        -3396.5,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5204.50048828125,
        981.70703125
      ],
      [
        -3396.5,
        -5204.50048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5204.50048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5207.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5207.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3407.800048828125,
        -5218.00048828125,
        982.3070068359375
      ],
      [
        -3413.199951171875,
        -5218.00048828125,
        982.3070068359375
      ],
      [
        -3413.199951171875,
        -5214.6005859375,
        982.3070068359375
      ],
      [
        -3407.800048828125,
        -5214.6005859375,
        982.3070068359375
      ],
      [
        -3413.199951171875,
        -5218.00048828125,
        982.3070068359375
      ],
      [
        -3413.199951171875,
        -5214.6005859375,
        982.3070068359375
      ],
      [
        -3407.800048828125,
        -5218.00048828125,
        982.3070068359375
      ],
      [
        -3407.800048828125,
        -5214.6005859375,
        982.3070068359375
      ],
      [
        -3404.0,
        -5220.00048828125,
        982.3070068359375
      ],
      [
        -3403.0,
        -5220.00048828125,
        982.3070068359375
      ],
      [
        -3404.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3404.0,
        -5220.00048828125,
        982.3070068359375
      ],
      [
        -3403.0,
        -5220.00048828125,
        982.3070068359375
      ],
      [
        -3403.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3514.6142578125,
        -5199.30029296875,
        982.3070068359375
      ],
      [
        -3491.550048828125,
        -5199.30029296875,
        982.3070068359375
      ],
      [
        -3491.550048828125,
        -5200.30029296875,
        982.3070068359375
      ],
      [
        -3491.699951171875,
        -5200.67529296875,
        982.0070190429688
      ],
      [
        -3491.699951171875,
        -5198.92578125,
        982.0070190429688
      ],
      [
        -3491.449951171875,
        -5198.92578125,
        982.0070190429688
      ],
      [
        -3491.449951171875,
        -5200.67529296875,
        982.0070190429688
      ],
      [
        -3491.300048828125,
        -5200.30029296875,
        982.3070068359375
      ],
      [
        -3491.300048828125,
        -5199.30029296875,
        982.3070068359375
      ],
      [
        -3495.449951171875,
        -5200.67529296875,
        982.0070190429688
      ],
      [
        -3495.449951171875,
        -5198.92578125,
        982.0070190429688
      ],
      [
        -3495.599853515625,
        -5199.30029296875,
        982.3070068359375
      ],
      [
        -3495.599853515625,
        -5200.30029296875,
        982.3070068359375
      ],
      [
        -3495.349853515625,
        -5200.30029296875,
        982.3070068359375
      ],
      [
        -3495.349853515625,
        -5199.30029296875,
        982.3070068359375
      ],
      [
        -3495.199951171875,
        -5198.92578125,
        982.0070190429688
      ],
      [
        -3495.199951171875,
        -5200.67529296875,
        982.0070190429688
      ],
      [
        -3483.96923828125,
        -5199.30029296875,
        982.3070068359375
      ],
      [
        -3484.170654296875,
        -5200.2998046875,
        982.3070068359375
      ],
      [
        -3484.809814453125,
        -5201.05029296875,
        981.70703125
      ],
      [
        -3484.30615234375,
        -5198.55078125,
        981.70703125
      ],
      [
        -3508.0,
        -5183.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5183.00048828125,
        982.3070068359375
      ],
      [
        -3483.124267578125,
        -5180.69970703125,
        982.3070068359375
      ],
      [
        -3483.197509765625,
        -5181.36083984375,
        982.3070068359375
      ],
      [
        -3482.39892578125,
        -5186.0888671875,
        982.3070068359375
      ],
      [
        -3483.124267578125,
        -5180.69970703125,
        982.3070068359375
      ],
      [
        -3483.197509765625,
        -5181.36083984375,
        982.3070068359375
      ],
      [
        -3482.510009765625,
        -5186.48974609375,
        982.3070068359375
      ],
      [
        -3483.155029296875,
        -5191.3984375,
        982.3070068359375
      ],
      [
        -3483.111328125,
        -5191.8720703125,
        982.3070068359375
      ],
      [
        -3483.399658203125,
        -5196.74072265625,
        982.3070068359375
      ],
      [
        -3482.39892578125,
        -5186.0888671875,
        982.3070068359375
      ],
      [
        -3482.510009765625,
        -5186.48974609375,
        982.3070068359375
      ],
      [
        -3483.489013671875,
        -5196.916015625,
        982.3070068359375
      ],
      [
        -3483.399658203125,
        -5196.74072265625,
        982.3070068359375
      ],
      [
        -3483.489013671875,
        -5196.916015625,
        982.3070068359375
      ],
      [
        -3483.111328125,
        -5191.8720703125,
        982.3070068359375
      ],
      [
        -3483.155029296875,
        -5191.3984375,
        982.3070068359375
      ],
      [
        -3491.300048828125,
        -5198.400390625,
        982.3070068359375
      ],
      [
        -3495.599853515625,
        -5198.400390625,
        982.3070068359375
      ],
      [
        -3495.599853515625,
        -5198.400390625,
        982.3070068359375
      ],
      [
        -3491.300048828125,
        -5198.400390625,
        982.3070068359375
      ],
      [
        -3491.550048828125,
        -5198.400390625,
        982.3070068359375
      ],
      [
        -3491.550048828125,
        -5198.650390625,
        982.3070068359375
      ],
      [
        -3491.300048828125,
        -5198.650390625,
        982.3070068359375
      ],
      [
        -3491.699951171875,
        -5198.80029296875,
        982.0070190429688
      ],
      [
        -3495.599853515625,
        -5198.650390625,
        982.3070068359375
      ],
      [
        -3495.349853515625,
        -5198.64990234375,
        982.3070068359375
      ],
      [
        -3495.349853515625,
        -5198.400390625,
        982.3070068359375
      ],
      [
        -3495.199951171875,
        -5198.80029296875,
        982.0070190429688
      ],
      [
        -3508.0,
        -5183.00048828125,
        982.3070068359375
      ],
      [
        -3507.0,
        -5183.00048828125,
        982.3070068359375
      ],
      [
        -3507.0,
        -5183.00048828125,
        982.3070068359375
      ],
      [
        -3507.0,
        -5182.00048828125,
        982.3070068359375
      ],
      [
        -3507.0,
        -5182.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5182.00048828125,
        982.3070068359375
      ],
      [
        -3484.119140625,
        -5214.3935546875,
        982.3070068359375
      ],
      [
        -3483.573974609375,
        -5220.79248046875,
        982.3070068359375
      ],
      [
        -3484.493408203125,
        -5207.1083984375,
        982.3070068359375
      ],
      [
        -3484.10302734375,
        -5214.05029296875,
        982.3070068359375
      ],
      [
        -3484.555908203125,
        -5202.25146484375,
        982.3070068359375
      ],
      [
        -3484.493408203125,
        -5207.1083984375,
        982.3070068359375
      ],
      [
        -3484.488037109375,
        -5201.875,
        982.3070068359375
      ],
      [
        -3484.488037109375,
        -5201.875,
        982.3070068359375
      ],
      [
        -3484.555908203125,
        -5202.25146484375,
        982.3070068359375
      ],
      [
        -3484.119140625,
        -5214.3935546875,
        982.3070068359375
      ],
      [
        -3484.10302734375,
        -5214.05029296875,
        982.3070068359375
      ],
      [
        -3495.599853515625,
        -5201.2001953125,
        982.3070068359375
      ],
      [
        -3491.300048828125,
        -5201.2001953125,
        982.3070068359375
      ],
      [
        -3495.599853515625,
        -5201.2001953125,
        982.3070068359375
      ],
      [
        -3491.300048828125,
        -5201.2001953125,
        982.3070068359375
      ],
      [
        -3491.550048828125,
        -5201.2001953125,
        982.3070068359375
      ],
      [
        -3491.300048828125,
        -5200.9501953125,
        982.3070068359375
      ],
      [
        -3491.550048828125,
        -5200.9501953125,
        982.3070068359375
      ],
      [
        -3491.699951171875,
        -5200.80029296875,
        982.0070190429688
      ],
      [
        -3495.599853515625,
        -5200.9501953125,
        982.3070068359375
      ],
      [
        -3495.349853515625,
        -5201.2001953125,
        982.3070068359375
      ],
      [
        -3495.349853515625,
        -5200.95068359375,
        982.3070068359375
      ],
      [
        -3495.199951171875,
        -5200.80029296875,
        982.0070190429688
      ],
      [
        -3483.573974609375,
        -5220.79248046875,
        982.3070068359375
      ],
      [
        -3483.576171875,
        -5221.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3422.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3421.5947265625,
        -5203.3837890625,
        982.3070068359375
      ],
      [
        -3423.357421875,
        -5206.02197265625,
        982.3070068359375
      ],
      [
        -3424.02294921875,
        -5205.3564453125,
        982.3070068359375
      ],
      [
        -3422.46435546875,
        -5203.0234375,
        982.3070068359375
      ],
      [
        -3422.46435546875,
        -5203.0234375,
        982.3070068359375
      ],
      [
        -3421.5947265625,
        -5203.3837890625,
        982.3070068359375
      ],
      [
        -3423.357421875,
        -5206.02197265625,
        982.3070068359375
      ],
      [
        -3424.02294921875,
        -5205.3564453125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3449.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3450.23095703125,
        -5197.50048828125,
        982.3070068359375
      ],
      [
        -3449.68359375,
        -5200.251953125,
        982.3070068359375
      ],
      [
        -3450.55322265625,
        -5200.6123046875,
        982.3070068359375
      ],
      [
        -3451.17236328125,
        -5197.50048828125,
        982.3070068359375
      ],
      [
        -3451.17236328125,
        -5197.50048828125,
        982.3070068359375
      ],
      [
        -3450.23095703125,
        -5197.50048828125,
        982.3070068359375
      ],
      [
        -3449.68359375,
        -5200.251953125,
        982.3070068359375
      ],
      [
        -3450.55322265625,
        -5200.6123046875,
        982.3070068359375
      ],
      [
        -3443.0,
        -5209.82763671875,
        981.70703125
      ],
      [
        -3445.521240234375,
        -5208.14306640625,
        982.3070068359375
      ],
      [
        -3443.0,
        -5209.82763671875,
        982.3070068359375
      ],
      [
        -3444.855712890625,
        -5207.4775390625,
        982.3070068359375
      ],
      [
        -3443.0,
        -5208.7177734375,
        981.70703125
      ],
      [
        -3443.0,
        -5208.7177734375,
        982.3070068359375
      ],
      [
        -3445.521240234375,
        -5208.14306640625,
        982.3070068359375
      ],
      [
        -3444.855712890625,
        -5207.4775390625,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3439.89990234375,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3442.523193359375,
        -5209.0361328125,
        982.3070068359375
      ],
      [
        -3442.88330078125,
        -5209.90576171875,
        982.3070068359375
      ],
      [
        -3442.523193359375,
        -5209.0361328125,
        982.3070068359375
      ],
      [
        -3442.88330078125,
        -5209.90576171875,
        982.3070068359375
      ],
      [
        -3439.5,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3441.0,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3441.0,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3441.0,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3439.5,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3439.5,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3441.0,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3439.5,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5195.00048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5195.00048828125,
        982.3070068359375
      ],
      [
        -3439.89990234375,
        -5195.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3431.10009765625,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3430.88818359375,
        -5211.0537109375,
        982.3070068359375
      ],
      [
        -3434.0,
        -5211.6728515625,
        982.3070068359375
      ],
      [
        -3434.0,
        -5210.7314453125,
        982.3070068359375
      ],
      [
        -3431.24853515625,
        -5210.18408203125,
        982.3070068359375
      ],
      [
        -3434.0,
        -5211.6728515625,
        982.3070068359375
      ],
      [
        -3434.0,
        -5210.7314453125,
        982.3070068359375
      ],
      [
        -3431.24853515625,
        -5210.18408203125,
        982.3070068359375
      ],
      [
        -3430.88818359375,
        -5211.0537109375,
        982.3070068359375
      ],
      [
        -3430.0,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3431.5,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3430.0,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3430.0,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3431.5,
        -5187.00048828125,
        982.3070068359375
      ],
      [
        -3431.5,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3431.5,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3430.0,
        -5185.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5195.00048828125,
        982.3070068359375
      ],
      [
        -3431.10009765625,
        -5195.00048828125,
        982.3070068359375
      ],
      [
        -3431.10009765625,
        -5195.00048828125,
        982.3070068359375
      ],
      [
        -3431.10009765625,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5196.00048828125,
        982.3070068359375
      ],
      [
        -3432.10009765625,
        -5195.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5178.00048828125,
        996.70703125
      ],
      [
        -3443.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3443.0,
        -5178.00048828125,
        996.70703125
      ],
      [
        -3443.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3453.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5178.00048828125,
        996.70703125
      ],
      [
        -3453.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5178.00048828125,
        986.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        985.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        985.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5178.00048828125,
        996.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        991.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        991.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        986.7069702148438
      ],
      [
        -3508.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3508.0,
        -5178.00048828125,
        996.7069702148438
      ],
      [
        -3468.01611328125,
        -5178.00048828125,
        991.4696044921875
      ],
      [
        -3470.782958984375,
        -5178.00048828125,
        988.7640991210938
      ],
      [
        -3461.1240234375,
        -5173.90771484375,
        996.7070922851562
      ],
      [
        -3463.543701171875,
        -5176.3056640625,
        996.7070922851562
      ],
      [
        -3453.2080078125,
        -5166.00048828125,
        996.6001586914062
      ],
      [
        -3467.474365234375,
        -5176.283203125,
        990.0916137695312
      ],
      [
        -3468.004638671875,
        -5176.775390625,
        989.8585815429688
      ],
      [
        -3463.543701171875,
        -5176.3056640625,
        996.7070922851562
      ],
      [
        -3464.889892578125,
        -5178.00048828125,
        996.7070922851562
      ],
      [
        -3468.01611328125,
        -5178.00048828125,
        991.4696044921875
      ],
      [
        -3458.0751953125,
        -5171.31396484375,
        996.7070922851562
      ],
      [
        -3461.1240234375,
        -5173.90771484375,
        996.7070922851562
      ],
      [
        -3458.0751953125,
        -5171.31396484375,
        996.7070922851562
      ],
      [
        -3479.779541015625,
        -5178.00048828125,
        984.9403076171875
      ],
      [
        -3483.989501953125,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3479.779541015625,
        -5178.00048828125,
        984.9403076171875
      ],
      [
        -3478.99609375,
        -5178.00048828125,
        985.6177978515625
      ],
      [
        -3485.2421875,
        -5172.3486328125,
        982.3070068359375
      ],
      [
        -3470.782958984375,
        -5178.00048828125,
        988.7640991210938
      ],
      [
        -3478.178466796875,
        -5178.00048828125,
        986.3248901367188
      ],
      [
        -3478.178466796875,
        -5178.00048828125,
        986.3248901367188
      ],
      [
        -3463.1923828125,
        -5173.087890625,
        991.8607177734375
      ],
      [
        -3472.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3474.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3474.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3472.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5156.00048828125,
        991.70703125
      ],
      [
        -3474.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3474.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3474.0,
        -5156.00048828125,
        991.70703125
      ],
      [
        -3474.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3493.402587890625,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3495.071044921875,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3486.76220703125,
        -5162.0,
        985.70703125
      ],
      [
        -3487.55615234375,
        -5162.0,
        985.70703125
      ],
      [
        -3486.76220703125,
        -5162.0,
        985.70703125
      ],
      [
        -3493.402587890625,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3497.00537109375,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3495.071044921875,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3493.0185546875,
        -5162.0,
        985.70703125
      ],
      [
        -3487.55615234375,
        -5162.0,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3495.071044921875,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3495.071044921875,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3497.00537109375,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3487.55615234375,
        -5162.0,
        986.70703125
      ],
      [
        -3487.55615234375,
        -5162.0,
        986.70703125
      ],
      [
        -3493.0185546875,
        -5162.0,
        986.70703125
      ],
      [
        -3497.00537109375,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3497.00537109375,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3493.0185546875,
        -5162.0,
        986.70703125
      ],
      [
        -3493.0185546875,
        -5162.0,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3482.385009765625,
        -5114.046875,
        993.8853149414062
      ],
      [
        -3471.01806640625,
        -5119.2353515625,
        996.7072143554688
      ],
      [
        -3471.213623046875,
        -5119.017578125,
        996.7072143554688
      ],
      [
        -3475.484130859375,
        -5118.05126953125,
        996.7072143554688
      ],
      [
        -3472.3818359375,
        -5117.7158203125,
        996.7072143554688
      ],
      [
        -3472.3818359375,
        -5117.7158203125,
        996.7072143554688
      ],
      [
        -3478.679443359375,
        -5117.7373046875,
        996.7072143554688
      ],
      [
        -3475.484130859375,
        -5118.05126953125,
        996.7072143554688
      ],
      [
        -3480.088623046875,
        -5116.7802734375,
        996.7072143554688
      ],
      [
        -3478.679443359375,
        -5117.7373046875,
        996.7072143554688
      ],
      [
        -3482.300537109375,
        -5114.07373046875,
        993.9212646484375
      ],
      [
        -3480.088623046875,
        -5116.7802734375,
        996.7072143554688
      ],
      [
        -3480.801513671875,
        -5116.44384765625,
        996.7072143554688
      ],
      [
        -3482.300537109375,
        -5114.07373046875,
        993.9212646484375
      ],
      [
        -3469.461181640625,
        -5120.9697265625,
        996.7072143554688
      ],
      [
        -3469.461181640625,
        -5120.9697265625,
        996.7072143554688
      ],
      [
        -3468.59326171875,
        -5121.72705078125,
        996.7072143554688
      ],
      [
        -3468.022705078125,
        -5121.4072265625,
        995.2302856445312
      ],
      [
        -3466.285888671875,
        -5124.0712890625,
        996.7072143554688
      ],
      [
        -3467.291748046875,
        -5122.962890625,
        996.7072143554688
      ],
      [
        -3468.022705078125,
        -5121.4072265625,
        995.2305908203125
      ],
      [
        -3468.20751953125,
        -5121.06103515625,
        994.8958740234375
      ],
      [
        -3458.313232421875,
        -5130.92578125,
        996.7072143554688
      ],
      [
        -3461.20166015625,
        -5128.42724609375,
        996.7072143554688
      ],
      [
        -3463.307373046875,
        -5126.55908203125,
        996.7072143554688
      ],
      [
        -3463.307373046875,
        -5126.55908203125,
        996.7072143554688
      ],
      [
        -3466.285888671875,
        -5124.0712890625,
        996.7072143554688
      ],
      [
        -3462.508544921875,
        -5121.9150390625,
        989.7449951171875
      ],
      [
        -3461.20166015625,
        -5128.42724609375,
        996.7072143554688
      ],
      [
        -3458.313232421875,
        -5130.92578125,
        996.7072143554688
      ],
      [
        -3458.66650390625,
        -5126.47216796875,
        992.425048828125
      ],
      [
        -3457.436767578125,
        -5127.57080078125,
        992.7301635742188
      ],
      [
        -3453.0,
        -5132.10400390625,
        994.7044677734375
      ],
      [
        -3458.66650390625,
        -5126.47216796875,
        992.425048828125
      ],
      [
        -3457.436767578125,
        -5127.57080078125,
        992.7301635742188
      ],
      [
        -3463.49658203125,
        -5118.37841796875,
        989.1222534179688
      ],
      [
        -3453.0,
        -5114.8505859375,
        987.498046875
      ],
      [
        -3467.730224609375,
        -5122.4794921875,
        996.7072143554688
      ],
      [
        -3467.730224609375,
        -5122.4794921875,
        996.7072143554688
      ],
      [
        -3480.8681640625,
        -5116.33837890625,
        996.58349609375
      ],
      [
        -3480.827880859375,
        -5116.43115234375,
        996.7072143554688
      ],
      [
        -3486.590087890625,
        -5114.4580078125,
        995.1175537109375
      ],
      [
        -3486.590087890625,
        -5114.4580078125,
        995.1175537109375
      ],
      [
        -3482.42236328125,
        -5115.67919921875,
        996.7072143554688
      ],
      [
        -3483.895263671875,
        -5115.5732421875,
        996.7072143554688
      ],
      [
        -3482.42236328125,
        -5115.67919921875,
        996.7072143554688
      ],
      [
        -3492.679931640625,
        -5114.50830078125,
        996.7072143554688
      ],
      [
        -3496.725341796875,
        -5114.4072265625,
        996.7072143554688
      ],
      [
        -3489.18017578125,
        -5115.22021484375,
        996.7072143554688
      ],
      [
        -3485.91845703125,
        -5115.42724609375,
        996.7072143554688
      ],
      [
        -3485.91845703125,
        -5115.42724609375,
        996.7072143554688
      ],
      [
        -3492.679931640625,
        -5114.50830078125,
        996.7072143554688
      ],
      [
        -3489.18017578125,
        -5115.22021484375,
        996.7072143554688
      ],
      [
        -3497.76416015625,
        -5114.38134765625,
        996.7072143554688
      ],
      [
        -3523.0,
        -5117.7109375,
        996.7072143554688
      ],
      [
        -3515.5771484375,
        -5116.0380859375,
        996.7072143554688
      ],
      [
        -3510.64453125,
        -5116.60595703125,
        996.7072143554688
      ],
      [
        -3515.5771484375,
        -5116.0380859375,
        996.7072143554688
      ],
      [
        -3505.802978515625,
        -5117.22314453125,
        996.7072143554688
      ],
      [
        -3505.67578125,
        -5117.177734375,
        996.7072143554688
      ],
      [
        -3510.64453125,
        -5116.60595703125,
        996.7072143554688
      ],
      [
        -3505.802978515625,
        -5117.22314453125,
        996.7072143554688
      ],
      [
        -3500.56689453125,
        -5115.353515625,
        996.7072143554688
      ],
      [
        -3497.840087890625,
        -5114.37939453125,
        996.7072143554688
      ],
      [
        -3499.494140625,
        -5114.33837890625,
        996.7072143554688
      ],
      [
        -3500.56689453125,
        -5115.353515625,
        996.7072143554688
      ],
      [
        -3499.494140625,
        -5114.33837890625,
        996.7072143554688
      ],
      [
        -3474.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3474.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3472.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3472.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3472.0,
        -5146.00048828125,
        991.70703125
      ],
      [
        -3472.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3474.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3474.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3474.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3474.0,
        -5146.00048828125,
        991.70703125
      ],
      [
        -3496.462646484375,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3495.071044921875,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3496.462646484375,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3497.00537109375,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3495.071044921875,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3454.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3453.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3483.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3483.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3483.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3483.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3454.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3454.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3474.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3472.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3472.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3472.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3474.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3474.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3495.071044921875,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3497.00537109375,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3495.071044921875,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3487.556396484375,
        -5140.0,
        986.70703125
      ],
      [
        -3493.01708984375,
        -5140.0,
        986.70703125
      ],
      [
        -3487.556396484375,
        -5140.0,
        986.70703125
      ],
      [
        -3497.00537109375,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3497.00537109375,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3493.01708984375,
        -5140.0,
        986.70703125
      ],
      [
        -3493.01708984375,
        -5140.0,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3492.634521484375,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3472.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3474.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3474.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3453.5,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5148.00048828125,
        992.70703125
      ],
      [
        -3453.0,
        -5154.00048828125,
        992.70703125
      ],
      [
        -3453.0,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3474.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3474.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3472.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5178.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3443.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3443.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5146.00048828125,
        991.70703125
      ],
      [
        -3443.0,
        -5136.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3443.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3443.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3453.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3443.0,
        -5166.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5156.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5147.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5147.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5147.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5155.00048828125,
        991.70703125
      ],
      [
        -3453.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5155.00048828125,
        991.70703125
      ],
      [
        -3449.0,
        -5167.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5166.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5136.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5135.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3449.0,
        -5142.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5142.70751953125,
        986.70703125
      ],
      [
        -3449.0,
        -5160.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5159.29345703125,
        986.70703125
      ],
      [
        -3453.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5160.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5160.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5160.00048828125,
        985.70703125
      ],
      [
        -3453.0,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5160.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5142.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5142.00048828125,
        986.70703125
      ],
      [
        -3453.0,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3449.0,
        -5142.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5142.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        985.70703125
      ],
      [
        -3453.0,
        -5148.00048828125,
        985.70703125
      ],
      [
        -3453.0,
        -5148.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        985.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        985.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        985.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        986.70703125
      ],
      [
        -3453.0,
        -5147.00048828125,
        986.70703125
      ],
      [
        -3453.0,
        -5147.00048828125,
        985.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        985.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        985.70703125
      ],
      [
        -3453.0,
        -5154.00048828125,
        986.70703125
      ],
      [
        -3453.0,
        -5154.00048828125,
        985.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        985.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        986.70703125
      ],
      [
        -3453.0,
        -5155.00048828125,
        985.70703125
      ],
      [
        -3453.0,
        -5155.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        986.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5160.00048828125,
        991.70703125
      ],
      [
        -3449.0,
        -5142.00048828125,
        991.70703125
      ],
      [
        -3449.0,
        -5142.70751953125,
        991.70703125
      ],
      [
        -3449.0,
        -5142.70751953125,
        986.70703125
      ],
      [
        -3449.0,
        -5159.29345703125,
        991.70703125
      ],
      [
        -3449.0,
        -5159.29345703125,
        986.70703125
      ],
      [
        -3443.0,
        -5136.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5136.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5135.00048828125,
        985.70703125
      ],
      [
        -3443.0,
        -5135.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5166.00048828125,
        985.70703125
      ],
      [
        -3443.0,
        -5166.00048828125,
        985.70703125
      ],
      [
        -3443.0,
        -5167.00048828125,
        985.70703125
      ],
      [
        -3449.0,
        -5167.00048828125,
        985.70703125
      ],
      [
        -3443.0,
        -5138.8291015625,
        984.70703125
      ],
      [
        -3443.0,
        -5138.8291015625,
        985.1070556640625
      ],
      [
        -3443.0,
        -5138.8291015625,
        985.1070556640625
      ],
      [
        -3443.0,
        -5138.8291015625,
        984.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        984.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        985.1766967773438
      ],
      [
        -3452.5,
        -5147.00048828125,
        985.388916015625
      ],
      [
        -3452.5,
        -5147.00048828125,
        984.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        984.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        985.388916015625
      ],
      [
        -3453.0,
        -5147.00048828125,
        985.4949340820312
      ],
      [
        -3453.0,
        -5147.00048828125,
        984.70703125
      ],
      [
        -3452.5,
        -5148.00048828125,
        985.1766967773438
      ],
      [
        -3452.5,
        -5148.00048828125,
        984.70703125
      ],
      [
        -3453.0,
        -5148.00048828125,
        984.70703125
      ],
      [
        -3453.0,
        -5148.00048828125,
        985.2827758789062
      ],
      [
        -3443.0,
        -5163.171875,
        984.70703125
      ],
      [
        -3443.0,
        -5163.171875,
        985.1070556640625
      ],
      [
        -3443.0,
        -5163.171875,
        985.1070556640625
      ],
      [
        -3443.0,
        -5163.171875,
        984.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        984.70703125
      ],
      [
        -3452.5,
        -5155.00048828125,
        985.388916015625
      ],
      [
        -3452.5,
        -5154.00048828125,
        985.1768798828125
      ],
      [
        -3452.5,
        -5154.00048828125,
        984.70703125
      ],
      [
        -3453.0,
        -5155.00048828125,
        984.70703125
      ],
      [
        -3453.0,
        -5155.00048828125,
        985.4949340820312
      ],
      [
        -3452.5,
        -5155.00048828125,
        985.388916015625
      ],
      [
        -3452.5,
        -5155.00048828125,
        984.70703125
      ],
      [
        -3453.0,
        -5154.00048828125,
        985.2828979492188
      ],
      [
        -3453.0,
        -5154.00048828125,
        984.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        984.70703125
      ],
      [
        -3452.5,
        -5154.00048828125,
        985.1768798828125
      ],
      [
        -3428.0,
        -5178.00048828125,
        996.70703125
      ],
      [
        -3428.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3428.0,
        -5178.00048828125,
        996.70703125
      ],
      [
        -3428.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5155.25048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5146.75048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5178.00048828125,
        996.70703125
      ],
      [
        -3418.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3418.0,
        -5178.00048828125,
        996.70703125
      ],
      [
        -3418.0,
        -5178.00048828125,
        982.3070068359375
      ],
      [
        -3395.929443359375,
        -5136.00048828125,
        993.4697875976562
      ],
      [
        -3398.92431640625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3398.82177734375,
        -5133.83154296875,
        996.7071533203125
      ],
      [
        -3397.419921875,
        -5134.39697265625,
        995.1629638671875
      ],
      [
        -3398.63671875,
        -5129.91162109375,
        996.7072143554688
      ],
      [
        -3398.63671875,
        -5129.91162109375,
        996.7072143554688
      ],
      [
        -3397.501708984375,
        -5127.57275390625,
        996.7072143554688
      ],
      [
        -3397.3935546875,
        -5127.35009765625,
        996.7072143554688
      ],
      [
        -3397.322998046875,
        -5127.205078125,
        996.7072143554688
      ],
      [
        -3397.713134765625,
        -5118.2314453125,
        996.7072143554688
      ],
      [
        -3397.19580078125,
        -5126.94287109375,
        996.7072143554688
      ],
      [
        -3397.19580078125,
        -5126.94287109375,
        996.7072143554688
      ],
      [
        -3397.713134765625,
        -5118.2314453125,
        996.7072143554688
      ],
      [
        -3397.671875,
        -5117.58740234375,
        996.7072143554688
      ],
      [
        -3364.0,
        -5119.00048828125,
        996.7072143554688
      ],
      [
        -3364.0,
        -5120.00048828125,
        996.7072143554688
      ],
      [
        -3364.0,
        -5119.00048828125,
        996.7072143554688
      ],
      [
        -3364.0,
        -5120.00048828125,
        996.7072143554688
      ],
      [
        -3397.576416015625,
        -5116.0947265625,
        996.7072143554688
      ],
      [
        -3397.459228515625,
        -5111.42333984375,
        996.7072143554688
      ],
      [
        -3399.710205078125,
        -5104.00048828125,
        996.707275390625
      ],
      [
        -3397.459228515625,
        -5111.42333984375,
        996.7072143554688
      ],
      [
        -3397.576416015625,
        -5116.0947265625,
        996.7072143554688
      ],
      [
        -3418.0,
        -5178.00048828125,
        995.70703125
      ],
      [
        -3416.0,
        -5178.00048828125,
        995.70703125
      ],
      [
        -3417.0,
        -5178.00048828125,
        990.0
      ],
      [
        -3417.0,
        -5178.00048828125,
        985.0
      ],
      [
        -3418.0,
        -5178.00048828125,
        990.0
      ],
      [
        -3417.0,
        -5178.00048828125,
        990.0
      ],
      [
        -3418.0,
        -5178.00048828125,
        985.0
      ],
      [
        -3417.0,
        -5178.00048828125,
        985.0
      ],
      [
        -3397.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3399.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3399.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3399.0,
        -5156.00048828125,
        991.70703125
      ],
      [
        -3399.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5156.50048828125,
        991.70703125
      ],
      [
        -3397.0,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5156.00048828125,
        991.70703125
      ],
      [
        -3399.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5156.00048828125,
        982.3070068359375
      ],
      [
        -3375.928955078125,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3377.597412109375,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3383.44384765625,
        -5162.0,
        985.70703125
      ],
      [
        -3384.23779296875,
        -5162.0,
        985.70703125
      ],
      [
        -3384.23779296875,
        -5162.0,
        985.70703125
      ],
      [
        -3378.365478515625,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3377.597412109375,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3375.928955078125,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3373.99462890625,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3383.44384765625,
        -5162.0,
        985.70703125
      ],
      [
        -3377.9814453125,
        -5162.0,
        985.70703125
      ],
      [
        -3375.928955078125,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3378.365478515625,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3373.99462890625,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3375.928955078125,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3383.44384765625,
        -5162.0,
        986.70703125
      ],
      [
        -3377.9814453125,
        -5162.0,
        986.70703125
      ],
      [
        -3383.44384765625,
        -5162.0,
        986.70703125
      ],
      [
        -3373.99462890625,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3373.99462890625,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3377.9814453125,
        -5162.0,
        985.70703125
      ],
      [
        -3377.9814453125,
        -5162.0,
        986.70703125
      ],
      [
        -3378.365478515625,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3378.365478515625,
        -5156.00048828125,
        985.70703125
      ],
      [
        -3399.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3397.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3397.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3399.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5146.00048828125,
        991.70703125
      ],
      [
        -3397.0,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5145.50048828125,
        991.70703125
      ],
      [
        -3397.0,
        -5146.00048828125,
        991.70703125
      ],
      [
        -3397.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3375.928955078125,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3374.537353515625,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3373.99462890625,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3374.537353515625,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3378.365478515625,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3375.928955078125,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3417.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3388.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3388.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3388.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3388.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3417.0,
        -5140.00048828125,
        985.70703125
      ],
      [
        -3417.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3399.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3397.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3399.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3399.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3397.0,
        -5145.50048828125,
        985.70703125
      ],
      [
        -3397.0,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3375.928955078125,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3378.365478515625,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3375.928955078125,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3373.99462890625,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3383.443603515625,
        -5140.0,
        986.70703125
      ],
      [
        -3383.443603515625,
        -5140.0,
        986.70703125
      ],
      [
        -3377.98291015625,
        -5140.0,
        986.70703125
      ],
      [
        -3373.99462890625,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3373.99462890625,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3377.98291015625,
        -5140.0,
        985.70703125
      ],
      [
        -3377.98291015625,
        -5140.0,
        986.70703125
      ],
      [
        -3378.365478515625,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3378.365478515625,
        -5146.00048828125,
        985.70703125
      ],
      [
        -3399.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5146.00048828125,
        982.3070068359375
      ],
      [
        -3397.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5147.00048828125,
        992.70703125
      ],
      [
        -3417.5,
        -5148.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3417.5,
        -5154.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5155.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3399.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3397.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3399.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3365.39990234375,
        -5154.00048828125,
        985.0070190429688
      ],
      [
        -3364.0498046875,
        -5152.65087890625,
        982.3070068359375
      ],
      [
        -3364.300048828125,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3364.25,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3364.25,
        -5152.900390625,
        982.70703125
      ],
      [
        -3361.0,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3365.39990234375,
        -5149.00048828125,
        985.0070190429688
      ],
      [
        -3364.050048828125,
        -5150.3505859375,
        982.3070068359375
      ],
      [
        -3364.300048828125,
        -5150.150390625,
        982.70703125
      ],
      [
        -3364.25,
        -5150.1005859375,
        982.70703125
      ],
      [
        -3364.25,
        -5150.150390625,
        982.70703125
      ],
      [
        -3364.25,
        -5152.8505859375,
        982.70703125
      ],
      [
        -3361.0,
        -5150.150390625,
        982.70703125
      ],
      [
        -3364.25,
        -5150.150390625,
        982.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5178.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3428.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5146.00048828125,
        996.7071533203125
      ],
      [
        -3428.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3428.0,
        -5136.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5146.00048828125,
        991.70703125
      ],
      [
        -3428.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3418.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5156.00048828125,
        996.7071533203125
      ],
      [
        -3428.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3418.0,
        -5156.00048828125,
        991.70703125
      ],
      [
        -3428.0,
        -5166.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5155.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5155.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5155.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5147.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5147.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        991.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5148.00048828125,
        992.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        992.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        992.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        991.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        992.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5154.00048828125,
        996.7071533203125
      ],
      [
        -3422.0,
        -5135.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5136.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5166.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5167.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        991.70703125
      ],
      [
        -3422.0,
        -5142.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5142.70751953125,
        986.70703125
      ],
      [
        -3422.0,
        -5160.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5159.29345703125,
        986.70703125
      ],
      [
        -3422.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3418.0,
        -5178.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5142.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5142.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5142.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5146.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5142.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5160.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5160.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5156.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5160.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5160.00048828125,
        986.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        986.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        985.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        985.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        985.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5147.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5147.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        985.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        985.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        985.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        985.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        986.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        985.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        986.70703125
      ],
      [
        -3418.0,
        -5155.00048828125,
        986.70703125
      ],
      [
        -3418.0,
        -5155.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5142.00048828125,
        991.70703125
      ],
      [
        -3422.0,
        -5160.00048828125,
        991.70703125
      ],
      [
        -3422.0,
        -5159.29345703125,
        991.70703125
      ],
      [
        -3422.0,
        -5159.29345703125,
        986.70703125
      ],
      [
        -3422.0,
        -5142.70751953125,
        991.70703125
      ],
      [
        -3422.0,
        -5142.70751953125,
        986.70703125
      ],
      [
        -3428.0,
        -5166.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5166.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5167.00048828125,
        985.70703125
      ],
      [
        -3428.0,
        -5167.00048828125,
        985.70703125
      ],
      [
        -3428.0,
        -5135.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5135.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5136.00048828125,
        985.70703125
      ],
      [
        -3428.0,
        -5136.00048828125,
        985.70703125
      ],
      [
        -3428.0,
        -5138.8291015625,
        984.70703125
      ],
      [
        -3428.0,
        -5138.8291015625,
        985.1070556640625
      ],
      [
        -3428.0,
        -5138.8291015625,
        985.1070556640625
      ],
      [
        -3428.0,
        -5138.8291015625,
        984.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        984.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        985.388916015625
      ],
      [
        -3418.5,
        -5148.00048828125,
        985.1765747070312
      ],
      [
        -3418.5,
        -5148.00048828125,
        984.70703125
      ],
      [
        -3418.0,
        -5147.00048828125,
        984.70703125
      ],
      [
        -3418.0,
        -5147.00048828125,
        985.4949340820312
      ],
      [
        -3418.5,
        -5147.00048828125,
        985.388916015625
      ],
      [
        -3418.5,
        -5147.00048828125,
        984.70703125
      ],
      [
        -3418.0,
        -5148.00048828125,
        985.2826538085938
      ],
      [
        -3418.0,
        -5148.00048828125,
        984.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        984.70703125
      ],
      [
        -3418.5,
        -5148.00048828125,
        985.1765747070312
      ],
      [
        -3428.0,
        -5163.171875,
        984.70703125
      ],
      [
        -3428.0,
        -5163.171875,
        985.1070556640625
      ],
      [
        -3428.0,
        -5163.171875,
        985.1070556640625
      ],
      [
        -3428.0,
        -5163.171875,
        984.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        984.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        985.1768798828125
      ],
      [
        -3418.5,
        -5155.00048828125,
        985.388916015625
      ],
      [
        -3418.5,
        -5155.00048828125,
        984.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        984.70703125
      ],
      [
        -3418.5,
        -5155.00048828125,
        985.388916015625
      ],
      [
        -3418.0,
        -5155.00048828125,
        985.4949340820312
      ],
      [
        -3418.0,
        -5155.00048828125,
        984.70703125
      ],
      [
        -3418.5,
        -5154.00048828125,
        985.1768798828125
      ],
      [
        -3418.5,
        -5154.00048828125,
        984.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        984.70703125
      ],
      [
        -3418.0,
        -5154.00048828125,
        985.2828979492188
      ],
      [
        -3431.0,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3432.0,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3439.10009765625,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3440.10009765625,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3432.0,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3431.0,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3440.10009765625,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3443.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3441.53759765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3441.53759765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3443.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3429.5,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3428.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3428.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3429.5,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3441.53759765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3429.5,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3429.5,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3441.53759765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3432.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3432.0,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3432.0,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3432.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3432.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3432.0,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3428.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3429.5,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3429.5,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3428.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3429.5,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3432.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3429.5,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3432.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3431.0,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3431.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3431.0,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3431.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3431.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3431.0,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3432.0,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3431.0,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3431.0,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3432.0,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3441.53759765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3443.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3443.0,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3441.53759765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3441.53759765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3441.53759765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3440.10009765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3440.10009765625,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3440.10009765625,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3440.10009765625,
        -5166.00048828125,
        996.7070922851562
      ],
      [
        -3440.10009765625,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3439.10009765625,
        -5136.400390625,
        996.7071533203125
      ],
      [
        -3439.10009765625,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3440.10009765625,
        -5165.6005859375,
        996.7070922851562
      ],
      [
        -3439.10009765625,
        -5166.00048828125,
        992.70703125
      ],
      [
        -3432.0,
        -5166.00048828125,
        992.70703125
      ],
      [
        -3432.0,
        -5136.00048828125,
        990.70703125
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        990.70703125
      ],
      [
        -3432.0,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3432.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3431.0,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3431.0,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3439.10009765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3439.10009765625,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3440.10009765625,
        -5135.6005859375,
        996.7071533203125
      ],
      [
        -3440.10009765625,
        -5136.00048828125,
        996.7071533203125
      ],
      [
        -3432.10009765625,
        -5104.00048828125,
        990.70703125
      ],
      [
        -3432.10009765625,
        -5104.50048828125,
        991.70703125
      ],
      [
        -3432.10009765625,
        -5104.50048828125,
        990.70703125
      ],
      [
        -3438.89990234375,
        -5104.00048828125,
        990.70703125
      ],
      [
        -3438.89990234375,
        -5104.50048828125,
        990.70703125
      ],
      [
        -3438.89990234375,
        -5104.50048828125,
        991.70703125
      ],
      [
        -3432.10009765625,
        -5105.00048828125,
        990.70703125
      ],
      [
        -3438.89990234375,
        -5105.00048828125,
        990.70703125
      ],
      [
        -3432.10009765625,
        -5104.50048828125,
        990.70703125
      ],
      [
        -3432.10009765625,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5104.50048828125,
        982.3070068359375
      ],
      [
        -3438.89990234375,
        -5104.50048828125,
        990.70703125
      ],
      [
        -3507.0,
        -5183.00048828125,
        996.7070922851562
      ],
      [
        -3507.0,
        -5182.00048828125,
        996.7070922851562
      ],
      [
        -3507.0,
        -5183.00048828125,
        996.7070922851562
      ],
      [
        -3507.0,
        -5182.00048828125,
        996.7070922851562
      ],
      [
        -3468.23291015625,
        -5181.95849609375,
        996.7070922851562
      ],
      [
        -3470.033935546875,
        -5183.6572265625,
        996.7070922851562
      ],
      [
        -3476.591796875,
        -5178.00048828125,
        986.8482666015625
      ],
      [
        -3467.156982421875,
        -5180.904296875,
        996.7070922851562
      ],
      [
        -3466.615234375,
        -5180.17236328125,
        996.7070922851562
      ],
      [
        -3466.615234375,
        -5180.17236328125,
        996.7070922851562
      ],
      [
        -3468.23291015625,
        -5181.95849609375,
        996.7070922851562
      ],
      [
        -3467.156982421875,
        -5180.904296875,
        996.7070922851562
      ],
      [
        -3472.693603515625,
        -5200.71875,
        996.70703125
      ],
      [
        -3472.58642578125,
        -5198.2353515625,
        996.70703125
      ],
      [
        -3472.07568359375,
        -5204.4345703125,
        996.70703125
      ],
      [
        -3472.693603515625,
        -5200.71875,
        996.70703125
      ],
      [
        -3472.58642578125,
        -5198.2353515625,
        996.70703125
      ],
      [
        -3472.2158203125,
        -5196.1171875,
        996.70703125
      ],
      [
        -3481.94384765625,
        -5196.57080078125,
        984.1216430664062
      ],
      [
        -3479.717529296875,
        -5198.171875,
        987.2555541992188
      ],
      [
        -3479.717529296875,
        -5198.171875,
        987.2555541992188
      ],
      [
        -3472.07568359375,
        -5204.4345703125,
        996.70703125
      ],
      [
        -3472.363525390625,
        -5209.33154296875,
        996.7069702148438
      ],
      [
        -3472.41259765625,
        -5213.05859375,
        996.7069702148438
      ],
      [
        -3472.363525390625,
        -5209.33154296875,
        996.7069702148438
      ],
      [
        -3471.080322265625,
        -5217.55126953125,
        996.7069702148438
      ],
      [
        -3472.41259765625,
        -5213.05859375,
        996.7069702148438
      ],
      [
        -3471.080322265625,
        -5217.55126953125,
        996.7069702148438
      ],
      [
        -3471.50732421875,
        -5188.48486328125,
        996.7070922851562
      ],
      [
        -3471.863037109375,
        -5185.38232421875,
        996.7070922851562
      ],
      [
        -3471.863037109375,
        -5185.38232421875,
        996.7070922851562
      ],
      [
        -3471.26318359375,
        -5191.68017578125,
        996.70703125
      ],
      [
        -3471.50732421875,
        -5188.48486328125,
        996.7070922851562
      ],
      [
        -3471.858642578125,
        -5192.88037109375,
        996.70703125
      ],
      [
        -3471.26318359375,
        -5191.68017578125,
        996.70703125
      ],
      [
        -3472.110595703125,
        -5195.5146484375,
        996.70703125
      ],
      [
        -3471.858642578125,
        -5192.88037109375,
        996.70703125
      ],
      [
        -3472.110595703125,
        -5195.5146484375,
        996.70703125
      ],
      [
        -3490.199951171875,
        -5202.30029296875,
        985.0070190429688
      ],
      [
        -3491.550048828125,
        -5200.95068359375,
        982.3070068359375
      ],
      [
        -3491.35009765625,
        -5201.150390625,
        982.70703125
      ],
      [
        -3491.300048828125,
        -5201.150390625,
        982.70703125
      ],
      [
        -3491.35009765625,
        -5201.20068359375,
        982.70703125
      ],
      [
        -3495.60009765625,
        -5201.150390625,
        982.70703125
      ],
      [
        -3495.5498046875,
        -5201.400390625,
        982.70703125
      ],
      [
        -3495.5498046875,
        -5201.15087890625,
        982.70703125
      ],
      [
        -3495.349853515625,
        -5200.95068359375,
        982.3070068359375
      ],
      [
        -3496.699951171875,
        -5202.30029296875,
        985.0070190429688
      ],
      [
        -3490.199951171875,
        -5197.30029296875,
        985.0070190429688
      ],
      [
        -3491.550048828125,
        -5198.650390625,
        982.3070068359375
      ],
      [
        -3491.35009765625,
        -5198.400390625,
        982.70703125
      ],
      [
        -3491.300048828125,
        -5198.4501953125,
        982.70703125
      ],
      [
        -3491.35009765625,
        -5198.4501953125,
        982.70703125
      ],
      [
        -3491.35009765625,
        -5201.150390625,
        982.70703125
      ],
      [
        -3495.60009765625,
        -5198.4501953125,
        982.70703125
      ],
      [
        -3491.35009765625,
        -5198.4501953125,
        982.70703125
      ],
      [
        -3495.5498046875,
        -5198.2001953125,
        982.70703125
      ],
      [
        -3495.349853515625,
        -5198.64990234375,
        982.3070068359375
      ],
      [
        -3495.5498046875,
        -5198.4501953125,
        982.70703125
      ],
      [
        -3496.699951171875,
        -5197.30078125,
        985.0070190429688
      ],
      [
        -3495.550048828125,
        -5198.4501953125,
        982.70703125
      ],
      [
        -3495.550048828125,
        -5201.150390625,
        982.70703125
      ],
      [
        -3428.0,
        -5206.91357421875,
        985.70703125
      ],
      [
        -3428.0,
        -5211.6318359375,
        985.70703125
      ],
      [
        -3428.0,
        -5211.6318359375,
        986.70703125
      ],
      [
        -3428.0,
        -5206.91357421875,
        986.70703125
      ],
      [
        -3422.0,
        -5206.6904296875,
        985.70703125
      ],
      [
        -3422.0,
        -5206.6904296875,
        986.70703125
      ],
      [
        -3422.0,
        -5196.00048828125,
        986.70703125
      ],
      [
        -3422.0,
        -5196.00048828125,
        985.70703125
      ],
      [
        -3428.0,
        -5196.00048828125,
        985.70703125
      ],
      [
        -3428.0,
        -5196.00048828125,
        986.70703125
      ],
      [
        -3428.0,
        -5196.00048828125,
        986.70703125
      ],
      [
        -3428.0,
        -5196.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5196.00048828125,
        985.70703125
      ],
      [
        -3422.0,
        -5196.00048828125,
        986.70703125
      ],
      [
        -3428.0,
        -5211.6318359375,
        985.70703125
      ],
      [
        -3428.0,
        -5211.6318359375,
        986.70703125
      ],
      [
        -3428.0,
        -5206.91357421875,
        986.70703125
      ],
      [
        -3428.0,
        -5206.91357421875,
        985.70703125
      ],
      [
        -3439.5,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3441.0,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3430.0,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3431.5,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3439.5,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3439.5,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3441.0,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3441.0,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3441.0,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3439.5,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3430.0,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3430.0,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3431.5,
        -5187.00048828125,
        996.70703125
      ],
      [
        -3431.5,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3431.5,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3430.0,
        -5185.00048828125,
        996.7070922851562
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        996.70703125
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        996.70703125
      ],
      [
        -3396.5,
        -5204.50048828125,
        996.70703125
      ],
      [
        -3396.5,
        -5207.00048828125,
        996.70703125
      ],
      [
        -3396.5,
        -5191.00048828125,
        996.70703125
      ],
      [
        -3396.5,
        -5193.50048828125,
        996.70703125
      ],
      [
        -3396.5,
        -5193.50048828125,
        996.70703125
      ],
      [
        -3399.89990234375,
        -5193.50048828125,
        996.70703125
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        996.70703125
      ],
      [
        -3398.699951171875,
        -5191.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5191.00048828125,
        996.70703125
      ],
      [
        -3396.5,
        -5191.00048828125,
        996.70703125
      ],
      [
        -3396.5,
        -5207.00048828125,
        996.70703125
      ],
      [
        -3398.699951171875,
        -5207.00048828125,
        982.3070068359375
      ],
      [
        -3398.699951171875,
        -5207.00048828125,
        996.70703125
      ],
      [
        -3398.699951171875,
        -5204.50048828125,
        982.3070068359375
      ],
      [
        -3396.5,
        -5204.50048828125,
        996.70703125
      ],
      [
        -3398.699951171875,
        -5204.50048828125,
        996.70703125
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        996.70703125
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        996.70703125
      ],
      [
        -3380.029541015625,
        -5205.5556640625,
        996.70703125
      ],
      [
        -3379.20556640625,
        -5207.544921875,
        996.70703125
      ],
      [
        -3379.20556640625,
        -5207.544921875,
        996.70703125
      ],
      [
        -3380.029541015625,
        -5209.53369140625,
        996.70703125
      ],
      [
        -3382.0185546875,
        -5204.73193359375,
        996.70703125
      ],
      [
        -3380.029541015625,
        -5205.5556640625,
        996.70703125
      ],
      [
        -3380.029541015625,
        -5209.53369140625,
        996.70703125
      ],
      [
        -3382.0185546875,
        -5210.35791015625,
        996.70703125
      ],
      [
        -3384.0078125,
        -5205.5556640625,
        996.70703125
      ],
      [
        -3382.0185546875,
        -5204.73193359375,
        996.70703125
      ],
      [
        -3382.0185546875,
        -5210.35791015625,
        996.70703125
      ],
      [
        -3384.0078125,
        -5209.53369140625,
        996.70703125
      ],
      [
        -3384.831787109375,
        -5207.544921875,
        996.70703125
      ],
      [
        -3384.0078125,
        -5205.5556640625,
        996.70703125
      ],
      [
        -3384.0078125,
        -5209.53369140625,
        996.70703125
      ],
      [
        -3384.831787109375,
        -5207.544921875,
        996.70703125
      ],
      [
        -3388.442138671875,
        -5210.20751953125,
        984.9204711914062
      ],
      [
        -3390.91064453125,
        -5205.3271484375,
        982.3070068359375
      ],
      [
        -3390.9150390625,
        -5209.73974609375,
        982.3070068359375
      ],
      [
        -3386.734619140625,
        -5215.40380859375,
        982.3070068359375
      ],
      [
        -3386.723388671875,
        -5199.66845703125,
        982.3070068359375
      ],
      [
        -3379.7734375,
        -5216.44287109375,
        982.3070068359375
      ],
      [
        -3379.768798828125,
        -5198.63623046875,
        982.3070068359375
      ],
      [
        -3374.127197265625,
        -5212.255859375,
        982.3070068359375
      ],
      [
        -3370.47509765625,
        -5189.49560546875,
        996.70703125
      ],
      [
        -3371.072021484375,
        -5190.93701171875,
        996.70703125
      ],
      [
        -3371.072021484375,
        -5188.0546875,
        996.70703125
      ],
      [
        -3370.47509765625,
        -5189.49560546875,
        996.70703125
      ],
      [
        -3371.072021484375,
        -5190.93701171875,
        996.70703125
      ],
      [
        -3372.513671875,
        -5191.5341796875,
        996.70703125
      ],
      [
        -3372.513671875,
        -5187.45751953125,
        996.70703125
      ],
      [
        -3371.072021484375,
        -5188.0546875,
        996.70703125
      ],
      [
        -3372.513671875,
        -5191.5341796875,
        996.70703125
      ],
      [
        -3373.955078125,
        -5190.93701171875,
        996.70703125
      ],
      [
        -3373.955078125,
        -5188.0546875,
        996.70703125
      ],
      [
        -3372.513671875,
        -5187.45751953125,
        996.70703125
      ],
      [
        -3373.955078125,
        -5190.93701171875,
        996.70703125
      ],
      [
        -3374.552001953125,
        -5189.49560546875,
        996.70703125
      ],
      [
        -3374.552001953125,
        -5189.49560546875,
        996.70703125
      ],
      [
        -3373.955078125,
        -5188.0546875,
        996.70703125
      ],
      [
        -3377.167724609375,
        -5187.56689453125,
        984.9209594726562
      ],
      [
        -3378.957275390625,
        -5191.10205078125,
        982.3070068359375
      ],
      [
        -3378.960205078125,
        -5187.90576171875,
        982.3070068359375
      ],
      [
        -3375.93017578125,
        -5183.80078125,
        982.3070068359375
      ],
      [
        -3375.9228515625,
        -5195.20361328125,
        982.3070068359375
      ],
      [
        -3370.886474609375,
        -5183.04833984375,
        982.3070068359375
      ],
      [
        -3370.88330078125,
        -5195.95166015625,
        982.3070068359375
      ],
      [
        -3366.795166015625,
        -5186.08203125,
        982.3070068359375
      ],
      [
        -3404.0,
        -5220.00048828125,
        996.7069702148438
      ],
      [
        -3404.0,
        -5220.00048828125,
        996.7069702148438
      ],
      [
        -3403.0,
        -5220.00048828125,
        996.7069702148438
      ],
      [
        -3403.0,
        -5220.00048828125,
        996.7069702148438
      ],
      [
        -3440.80419921875,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3430.19580078125,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3440.80419921875,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3430.19580078125,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3428.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3443.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3431.5,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3430.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3441.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3431.5,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3431.5,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3431.5,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3430.0,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3430.0,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3430.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3431.5,
        -5104.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5104.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5112.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5112.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5104.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5104.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5111.00048828125,
        1002.70703125
      ],
      [
        -3430.0,
        -5111.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5111.00048828125,
        1002.70703125
      ],
      [
        -3428.0,
        -5112.00048828125,
        1002.70703125
      ],
      [
        -3428.0,
        -5104.00048828125,
        1002.70703125
      ],
      [
        -3429.0,
        -5111.00048828125,
        1002.70703125
      ],
      [
        -3429.0,
        -5104.00048828125,
        1002.70703125
      ],
      [
        -3429.0,
        -5111.00048828125,
        1002.70703125
      ],
      [
        -3431.5,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5112.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3441.0,
        -5112.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5111.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5111.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5111.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5112.00048828125,
        1003.70703125
      ],
      [
        -3441.0,
        -5112.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5111.00048828125,
        1003.70703125
      ],
      [
        -3428.0,
        -5136.00048828125,
        999.70703125
      ],
      [
        -3443.0,
        -5136.00048828125,
        999.70703125
      ],
      [
        -3428.0,
        -5136.00048828125,
        999.70703125
      ],
      [
        -3428.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3443.0,
        -5136.00048828125,
        1000.70703125
      ],
      [
        -3443.0,
        -5136.00048828125,
        999.70703125
      ],
      [
        -3398.433837890625,
        -5129.49365234375,
        996.7072143554688
      ],
      [
        -3478.945556640625,
        -5121.8095703125,
        1003.70703125
      ],
      [
        -3496.75,
        -5120.91943359375,
        1003.70703125
      ],
      [
        -3473.102294921875,
        -5117.7939453125,
        996.7072143554688
      ],
      [
        -3460.508544921875,
        -5133.99267578125,
        1003.70703125
      ],
      [
        -3464.87109375,
        -5125.2529296875,
        996.7072143554688
      ],
      [
        -3457.958251953125,
        -5196.00048828125,
        1003.70703125
      ],
      [
        -3418.0,
        -5197.87548828125,
        999.70703125
      ],
      [
        -3419.0,
        -5197.87548828125,
        999.70703125
      ],
      [
        -3418.0,
        -5197.87548828125,
        999.70703125
      ],
      [
        -3419.0,
        -5197.87548828125,
        999.70703125
      ],
      [
        -3469.36083984375,
        -5196.00048828125,
        1000.7542724609375
      ],
      [
        -3471.073486328125,
        -5197.18701171875,
        998.60546875
      ],
      [
        -3472.195556640625,
        -5196.00048828125,
        996.70703125
      ],
      [
        -3468.96875,
        -5196.00048828125,
        1001.1966552734375
      ],
      [
        -3468.628173828125,
        -5198.7353515625,
        1001.0830688476562
      ],
      [
        -3470.453857421875,
        -5197.7060546875,
        999.4358520507812
      ],
      [
        -3469.185791015625,
        -5196.00048828125,
        1000.9805908203125
      ],
      [
        -3469.185791015625,
        -5196.00048828125,
        1000.9805908203125
      ],
      [
        -3470.453857421875,
        -5197.7060546875,
        999.4358520507812
      ],
      [
        -3471.073486328125,
        -5197.18701171875,
        998.60546875
      ],
      [
        -3469.36083984375,
        -5196.00048828125,
        1000.7542724609375
      ],
      [
        -3466.586669921875,
        -5196.00048828125,
        1003.70703125
      ],
      [
        -3466.532958984375,
        -5199.98095703125,
        1003.0756225585938
      ],
      [
        -3468.628173828125,
        -5198.7353515625,
        1001.0830688476562
      ],
      [
        -3468.96875,
        -5196.00048828125,
        1001.1966552734375
      ],
      [
        -3466.532958984375,
        -5199.98095703125,
        1003.0756225585938
      ],
      [
        -3466.0888671875,
        -5200.37548828125,
        1003.70703125
      ],
      [
        -3455.316650390625,
        -5170.88623046875,
        999.9772338867188
      ],
      [
        -3456.7109375,
        -5173.2275390625,
        1001.9458618164062
      ],
      [
        -3457.95849609375,
        -5175.6474609375,
        1003.70703125
      ],
      [
        -3456.7109375,
        -5173.2275390625,
        1001.9458618164062
      ],
      [
        -3455.316650390625,
        -5170.88623046875,
        999.9772338867188
      ],
      [
        -3469.337646484375,
        -5183.00048828125,
        996.7070922851562
      ],
      [
        -3468.27734375,
        -5182.00048828125,
        996.7070922851562
      ],
      [
        -3468.24267578125,
        -5182.00048828125,
        996.7639770507812
      ],
      [
        -3468.403564453125,
        -5182.69677734375,
        997.7070922851562
      ],
      [
        -3468.7255859375,
        -5183.00048828125,
        997.7070922851562
      ],
      [
        -3468.403564453125,
        -5182.69677734375,
        997.7070922851562
      ],
      [
        -3468.24267578125,
        -5182.00048828125,
        996.7639770507812
      ],
      [
        -3467.69287109375,
        -5182.00048828125,
        997.7070922851562
      ],
      [
        -3468.4736328125,
        -5183.00048828125,
        998.11865234375
      ],
      [
        -3464.627197265625,
        -5182.00048828125,
        1002.9666748046875
      ],
      [
        -3465.96044921875,
        -5183.00048828125,
        1002.43017578125
      ],
      [
        -3465.96044921875,
        -5183.00048828125,
        1002.43017578125
      ],
      [
        -3464.627197265625,
        -5182.00048828125,
        1002.9666748046875
      ],
      [
        -3464.199951171875,
        -5182.00048828125,
        1003.70703125
      ],
      [
        -3465.2236328125,
        -5183.00048828125,
        1003.70703125
      ],
      [
        -3468.4736328125,
        -5183.00048828125,
        998.11865234375
      ],
      [
        -3466.7998046875,
        -5190.10498046875,
        1003.70703125
      ],
      [
        -3430.0,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3430.19580078125,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3430.19580078125,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3431.5,
        -5166.400390625,
        1000.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3428.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3430.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3430.0,
        -5186.17236328125,
        1000.70703125
      ],
      [
        -3430.0,
        -5185.00048828125,
        1000.70703125
      ],
      [
        -3430.0,
        -5185.00048828125,
        1000.70703125
      ],
      [
        -3430.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3430.0,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3431.5,
        -5186.17236328125,
        1000.70703125
      ],
      [
        -3430.0,
        -5186.17236328125,
        1000.70703125
      ],
      [
        -3431.5,
        -5166.400390625,
        999.70703125
      ],
      [
        -3431.5,
        -5166.400390625,
        1000.70703125
      ],
      [
        -3431.5,
        -5166.400390625,
        999.70703125
      ],
      [
        -3431.5,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3431.5,
        -5166.400390625,
        999.70703125
      ],
      [
        -3428.0,
        -5166.00048828125,
        999.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        999.70703125
      ],
      [
        -3428.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3428.0,
        -5166.00048828125,
        999.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5185.4150390625,
        1001.70703125
      ],
      [
        -3439.5,
        -5183.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5183.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3440.80419921875,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3440.80419921875,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5166.400390625,
        1000.70703125
      ],
      [
        -3443.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3441.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3441.0,
        -5185.00048828125,
        1000.70703125
      ],
      [
        -3441.0,
        -5186.17236328125,
        1000.70703125
      ],
      [
        -3441.0,
        -5183.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5185.4150390625,
        1001.70703125
      ],
      [
        -3441.0,
        -5185.00048828125,
        1000.70703125
      ],
      [
        -3441.0,
        -5183.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3441.0,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5186.17236328125,
        1000.70703125
      ],
      [
        -3439.5,
        -5186.17236328125,
        1000.70703125
      ],
      [
        -3441.0,
        -5185.4150390625,
        1001.70703125
      ],
      [
        -3439.5,
        -5185.4150390625,
        1001.70703125
      ],
      [
        -3439.5,
        -5166.400390625,
        999.70703125
      ],
      [
        -3439.5,
        -5166.400390625,
        1000.70703125
      ],
      [
        -3439.5,
        -5166.400390625,
        999.70703125
      ],
      [
        -3439.5,
        -5166.400390625,
        996.7070922851562
      ],
      [
        -3443.0,
        -5166.00048828125,
        999.70703125
      ],
      [
        -3439.5,
        -5166.400390625,
        999.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        999.70703125
      ],
      [
        -3443.0,
        -5166.00048828125,
        999.70703125
      ],
      [
        -3443.0,
        -5166.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3441.0,
        -5166.00048828125,
        1002.70703125
      ],
      [
        -3362.199951171875,
        -5196.00048828125,
        996.70703125
      ],
      [
        -3362.199951171875,
        -5196.62548828125,
        997.70703125
      ],
      [
        -3362.199951171875,
        -5196.62548828125,
        997.70703125
      ],
      [
        -3359.800048828125,
        -5196.62548828125,
        997.70703125
      ],
      [
        -3359.800048828125,
        -5196.62548828125,
        997.70703125
      ],
      [
        -3359.800048828125,
        -5196.00048828125,
        996.70703125
      ],
      [
        -3399.89990234375,
        -5191.00048828125,
        997.70703125
      ],
      [
        -3397.5,
        -5191.00048828125,
        996.70703125
      ],
      [
        -3397.5,
        -5191.00048828125,
        997.70703125
      ],
      [
        -3397.5,
        -5191.00048828125,
        1003.70703125
      ],
      [
        -3374.41162109375,
        -5189.15673828125,
        996.70703125
      ],
      [
        -3374.095458984375,
        -5188.3935546875,
        996.70703125
      ],
      [
        -3372.855712890625,
        -5187.59912109375,
        996.70703125
      ],
      [
        -3371.417236328125,
        -5187.91162109375,
        996.70703125
      ],
      [
        -3370.618408203125,
        -5189.1494140625,
        996.70703125
      ],
      [
        -3374.0966796875,
        -5190.59521484375,
        996.70703125
      ],
      [
        -3372.85791015625,
        -5191.3916015625,
        996.70703125
      ],
      [
        -3370.92919921875,
        -5190.59228515625,
        996.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3388.0,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3388.0,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3483.0,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3483.0,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3398.5859375,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3401.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3470.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3472.4140625,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3401.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3470.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3472.4140625,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3470.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3401.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3398.5859375,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3401.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3470.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3472.4140625,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3470.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3401.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3398.5859375,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3401.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3470.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3417.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3453.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3439.5,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3473.171630859375,
        -5145.50048828125,
        1000.70703125
      ],
      [
        -3473.171630859375,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3472.4140625,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3472.4140625,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3397.828369140625,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3397.828369140625,
        -5145.50048828125,
        1000.70703125
      ],
      [
        -3398.5859375,
        -5147.00048828125,
        1001.70703125
      ],
      [
        -3398.5859375,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3453.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3453.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3453.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5145.50048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5145.50048828125,
        1000.70703125
      ],
      [
        -3452.5,
        -5145.50048828125,
        1000.70703125
      ],
      [
        -3452.5,
        -5145.50048828125,
        999.70703125
      ],
      [
        -3453.0,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3453.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3453.0,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5145.50048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5145.50048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3417.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3417.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3417.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        999.70703125
      ],
      [
        -3418.5,
        -5147.00048828125,
        1000.70703125
      ],
      [
        -3418.5,
        -5145.50048828125,
        999.7080688476562
      ],
      [
        -3418.5,
        -5145.50048828125,
        1000.7080688476562
      ],
      [
        -3418.5,
        -5145.50048828125,
        1000.7080688476562
      ],
      [
        -3418.5,
        -5145.50048828125,
        999.7080688476562
      ],
      [
        -3418.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3418.0,
        -5147.00048828125,
        999.7081298828125
      ],
      [
        -3418.0,
        -5147.00048828125,
        999.7081298828125
      ],
      [
        -3418.0,
        -5147.00048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5145.50048828125,
        999.7080688476562
      ],
      [
        -3418.5,
        -5145.50048828125,
        999.7080688476562
      ],
      [
        -3418.5,
        -5145.50048828125,
        996.7071533203125
      ],
      [
        -3430.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3397.828369140625,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3399.0,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3398.5859375,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3401.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3399.0,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3472.0,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3470.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3472.4140625,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3472.0,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3473.171630859375,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3401.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3470.0,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3473.171630859375,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3473.171630859375,
        -5156.50048828125,
        1000.70703125
      ],
      [
        -3472.4140625,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3472.4140625,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3397.828369140625,
        -5156.50048828125,
        1000.70703125
      ],
      [
        -3397.828369140625,
        -5155.00048828125,
        1000.70703125
      ],
      [
        -3398.5859375,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3398.5859375,
        -5155.00048828125,
        1001.70703125
      ],
      [
        -3452.5,
        -5156.50048828125,
        1000.70703125
      ],
      [
        -3452.5,
        -5156.50048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5156.50048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5156.50048828125,
        1000.70703125
      ],
      [
        -3452.5,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3452.5,
        -5156.50048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5156.50048828125,
        999.70703125
      ],
      [
        -3452.5,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5156.50048828125,
        999.7080688476562
      ],
      [
        -3418.5,
        -5156.50048828125,
        1000.7080688476562
      ],
      [
        -3418.5,
        -5156.50048828125,
        1000.7080688476562
      ],
      [
        -3418.5,
        -5156.50048828125,
        999.7080688476562
      ],
      [
        -3418.5,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3418.5,
        -5156.50048828125,
        999.7080688476562
      ],
      [
        -3418.5,
        -5156.50048828125,
        999.7080688476562
      ],
      [
        -3418.5,
        -5156.50048828125,
        996.7071533203125
      ],
      [
        -3431.5,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5156.50048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5166.00048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3439.5,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3441.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3430.0,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5136.00048828125,
        1001.70703125
      ],
      [
        -3431.5,
        -5145.50048828125,
        1001.70703125
      ],
      [
        -3466.124755859375,
        -5204.7783203125,
        1003.70703125
      ],
      [
        -3472.2822265625,
        -5203.1923828125,
        996.70703125
      ],
      [
        -3404.0,
        -5222.20068359375,
        996.7069702148438
      ],
      [
        -3404.0,
        -5220.6669921875,
        997.70703125
      ],
      [
        -3404.0,
        -5222.20068359375,
        997.70703125
      ],
      [
        -3404.0,
        -5220.6669921875,
        997.70703125
      ],
      [
        -3404.0,
        -5220.00048828125,
        997.70703125
      ],
      [
        -3403.0,
        -5220.6669921875,
        997.70703125
      ],
      [
        -3403.0,
        -5222.20068359375,
        996.7069702148438
      ],
      [
        -3403.0,
        -5222.20068359375,
        997.70703125
      ],
      [
        -3403.0,
        -5220.00048828125,
        997.70703125
      ],
      [
        -3403.0,
        -5220.6669921875,
        997.70703125
      ],
      [
        -3418.0,
        -5220.00048828125,
        996.7069702148438
      ],
      [
        -3418.0,
        -5221.00048828125,
        997.70703125
      ],
      [
        -3418.0,
        -5220.00048828125,
        997.70703125
      ],
      [
        -3418.0,
        -5221.00048828125,
        997.70703125
      ],
      [
        -3419.0,
        -5221.00048828125,
        997.70703125
      ],
      [
        -3419.0,
        -5221.00048828125,
        997.70703125
      ],
      [
        -3419.0,
        -5220.00048828125,
        996.70703125
      ],
      [
        -3419.0,
        -5220.00048828125,
        997.70703125
      ],
      [
        -3404.0,
        -5222.20068359375,
        999.7069702148438
      ],
      [
        -3403.0,
        -5222.20068359375,
        999.7069702148438
      ],
      [
        -3404.0,
        -5222.20068359375,
        999.7069702148438
      ],
      [
        -3403.0,
        -5222.20068359375,
        999.7069702148438
      ],
      [
        -3418.0,
        -5220.00048828125,
        999.70703125
      ],
      [
        -3419.0,
        -5220.00048828125,
        999.70703125
      ],
      [
        -3418.0,
        -5220.00048828125,
        999.70703125
      ],
      [
        -3419.0,
        -5220.00048828125,
        999.70703125
      ],
      [
        -3397.5,
        -5207.00048828125,
        996.70703125
      ],
      [
        -3399.89990234375,
        -5207.00048828125,
        997.70703125
      ],
      [
        -3397.5,
        -5207.00048828125,
        997.70703125
      ],
      [
        -3399.89990234375,
        -5204.50048828125,
        997.70703125
      ],
      [
        -3397.5,
        -5204.50048828125,
        996.70703125
      ],
      [
        -3397.5,
        -5204.50048828125,
        997.70703125
      ],
      [
        -3397.5,
        -5207.00048828125,
        1003.70703125
      ],
      [
        -3397.5,
        -5204.50048828125,
        1003.70703125
      ],
      [
        -3384.20166015625,
        -5209.0654296875,
        996.70703125
      ],
      [
        -3384.637939453125,
        -5208.0126953125,
        996.70703125
      ],
      [
        -3382.49072265625,
        -5210.162109375,
        996.70703125
      ],
      [
        -3380.505615234375,
        -5209.73095703125,
        996.70703125
      ],
      [
        -3379.403564453125,
        -5208.0224609375,
        996.70703125
      ],
      [
        -3384.203125,
        -5206.02734375,
        996.70703125
      ],
      [
        -3382.494384765625,
        -5204.92919921875,
        996.70703125
      ],
      [
        -3380.50732421875,
        -5205.35791015625,
        996.70703125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3373.0,
      "bbox_min": [
        -3373.0,
        -5096.00048828125,
        1003.70703125
      ],
      "bbox_max": [
        -3373.0,
        -5095.00048828125,
        1006.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5094.0,
      "bbox_min": [
        -3362.5,
        -5094.0,
        1005.0
      ],
      "bbox_max": [
        -3362.0,
        -5091.0,
        1006.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1007.0,
      "bbox_min": [
        -3362.5,
        -5094.0,
        1006.70703125
      ],
      "bbox_max": [
        -3362.0,
        -5091.0,
        1007.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7688345909118652,
        0.21359612047672272,
        0.6027188301086426
      ],
      "plane_d": -2161.715087890625,
      "bbox_min": [
        -3483.0,
        -5186.56005859375,
        981.70703125
      ],
      "bbox_max": [
        -3482.39892578125,
        -5186.0888671875,
        982.3070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7665289640426636,
        0.1544264256954193,
        0.6233665347099304
      ],
      "plane_d": -2479.991455078125,
      "bbox_min": [
        -3484.30615234375,
        -5199.30029296875,
        981.70703125
      ],
      "bbox_max": [
        -3483.111328125,
        -5191.3984375,
        982.3070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7393491268157959,
        0.3770211935043335,
        0.5578690767288208
      ],
      "plane_d": -1164.165771484375,
      "bbox_min": [
        -3484.0,
        -5197.0302734375,
        981.70703125
      ],
      "bbox_max": [
        -3483.399658203125,
        -5196.74072265625,
        982.3070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7195085287094116,
        -0.066433385014534,
        0.6912988424301147
      ],
      "plane_d": -3530.109375,
      "bbox_min": [
        -3483.69189453125,
        -5191.8720703125,
        981.70703125
      ],
      "bbox_max": [
        -3483.111328125,
        -5191.3984375,
        982.3070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6247076392173767,
        0.0,
        0.7808586955070496
      ],
      "plane_d": 1378.827880859375,
      "bbox_min": [
        -3443.0,
        -5221.00048828125,
        981.7069702148438
      ],
      "bbox_max": [
        -3428.0,
        -5185.00048828125,
        982.3070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 5195.00048828125,
      "bbox_min": [
        -3439.89990234375,
        -5195.00048828125,
        981.70703125
      ],
      "bbox_max": [
        -3438.89990234375,
        -5195.00048828125,
        982.3070068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1192.88916015625,
      "bbox_min": [
        -3453.0,
        -5140.00048828125,
        986.70703125
      ],
      "bbox_max": [
        -3449.0,
        -5136.00048828125,
        991.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5148.00048828125,
      "bbox_min": [
        -3418.0,
        -5155.00048828125,
        982.3070068359375
      ],
      "bbox_max": [
        -3417.5,
        -5147.00048828125,
        996.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 5154.00048828125,
      "bbox_min": [
        -3418.0,
        -5155.00048828125,
        982.3070068359375
      ],
      "bbox_max": [
        -3417.5,
        -5148.00048828125,
        996.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -992.70703125,
      "bbox_min": [
        -3418.0,
        -5155.00048828125,
        992.70703125
      ],
      "bbox_max": [
        -3417.5,
        -5154.00048828125,
        992.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5155.00048828125,
      "bbox_min": [
        -3418.5,
        -5155.00048828125,
        991.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5147.00048828125,
        996.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -5148.00048828125,
      "bbox_min": [
        -3418.5,
        -5155.00048828125,
        991.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5147.00048828125,
        996.7071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -5155.00048828125,
      "bbox_min": [
        -3418.5,
        -5155.00048828125,
        986.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5155.00048828125,
        991.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555703043937683,
        0.8314695954322815,
        0.0
      ],
      "plane_d": 2424.89501953125,
      "bbox_min": [
        -3428.0,
        -5206.91357421875,
        985.70703125
      ],
      "bbox_max": [
        -3425.9541015625,
        -5205.54638671875,
        986.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3417.0,
      "bbox_min": [
        -3418.0,
        -5220.6005859375,
        982.3070068359375
      ],
      "bbox_max": [
        -3407.800048828125,
        -5190.0,
        990.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9058237671852112,
        0.3752165734767914,
        0.19671249389648438
      ],
      "plane_d": 4818.857421875,
      "bbox_min": [
        -3380.50732421875,
        -5208.0224609375,
        996.70703125
      ],
      "bbox_max": [
        -3379.20556640625,
        -5205.35791015625,
        998.528564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9059251546859741,
        -0.37526190280914307,
        0.1961584985256195
      ],
      "plane_d": 911.6015625,
      "bbox_min": [
        -3380.50732421875,
        -5208.0224609375,
        996.70703125
      ],
      "bbox_max": [
        -3379.20556640625,
        -5205.35791015625,
        998.528564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37525954842567444,
        0.9059664607048035,
        0.19597208499908447
      ],
      "plane_d": 5789.12060546875,
      "bbox_min": [
        -3380.50732421875,
        -5205.83349609375,
        996.70703125
      ],
      "bbox_max": [
        -3380.029541015625,
        -5205.35791015625,
        998.528564453125
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 2783,
      "centroid": [
        -3435.550048828125,
        -5136.00048828125,
        986.20703125
      ],
      "bbox_min": [
        -3437.60009765625,
        -5136.00048828125,
        981.70703125
      ],
      "bbox_max": [
        -3433.5,
        -5136.00048828125,
        990.70703125
      ],
      "dimensions_source": {
        "span_x": 4.10009765625,
        "span_y": 0.0,
        "height_z": 9.0,
        "door_width": 4.10009765625,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3433.5,
          -5136.00048828125,
          981.70703125
        ],
        [
          -3433.5,
          -5136.00048828125,
          981.70703125
        ],
        [
          -3433.5,
          -5136.00048828125,
          990.70703125
        ],
        [
          -3433.5,
          -5136.00048828125,
          990.70703125
        ],
        [
          -3437.60009765625,
          -5136.00048828125,
          981.70703125
        ],
        [
          -3437.60009765625,
          -5136.00048828125,
          981.70703125
        ],
        [
          -3437.60009765625,
          -5136.00048828125,
          990.70703125
        ],
        [
          -3437.60009765625,
          -5136.00048828125,
          990.70703125
        ]
      ],
      "plane_distance": -5136.0005,
      "authentic_texture": "mineblock"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 3511,
      "centroid": [
        -3435.550048828125,
        -5104.50048828125,
        986.20703125
      ],
      "bbox_min": [
        -3437.60009765625,
        -5104.50048828125,
        981.70703125
      ],
      "bbox_max": [
        -3433.5,
        -5104.50048828125,
        990.70703125
      ],
      "dimensions_source": {
        "span_x": 4.10009765625,
        "span_y": 0.0,
        "height_z": 9.0,
        "door_width": 4.10009765625,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3433.5,
          -5104.50048828125,
          981.70703125
        ],
        [
          -3433.5,
          -5104.50048828125,
          981.70703125
        ],
        [
          -3433.5,
          -5104.50048828125,
          990.70703125
        ],
        [
          -3433.5,
          -5104.50048828125,
          990.70703125
        ],
        [
          -3437.60009765625,
          -5104.50048828125,
          981.70703125
        ],
        [
          -3437.60009765625,
          -5104.50048828125,
          981.70703125
        ],
        [
          -3437.60009765625,
          -5104.50048828125,
          990.70703125
        ],
        [
          -3437.60009765625,
          -5104.50048828125,
          990.70703125
        ]
      ],
      "plane_distance": -5104.5005,
      "authentic_texture": "mineblock"
    },
    {
      "tag": "CSlidingDoor piece: fdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "fdr1",
      "offset": 4273,
      "centroid": [
        -3418.0,
        -5151.00048828125,
        986.70703125
      ],
      "bbox_min": [
        -3418.0,
        -5154.00048828125,
        981.70703125
      ],
      "bbox_max": [
        -3418.0,
        -5148.00048828125,
        991.70703125
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 6.0,
        "height_z": 10.0,
        "door_width": 6.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3418.0,
          -5154.00048828125,
          981.70703125
        ],
        [
          -3418.0,
          -5154.00048828125,
          981.70703125
        ],
        [
          -3418.0,
          -5154.00048828125,
          991.70703125
        ],
        [
          -3418.0,
          -5154.00048828125,
          991.70703125
        ],
        [
          -3418.0,
          -5148.00048828125,
          991.70703125
        ],
        [
          -3418.0,
          -5148.00048828125,
          991.70703125
        ],
        [
          -3418.0,
          -5148.00048828125,
          981.70703125
        ],
        [
          -3418.0,
          -5148.00048828125,
          981.70703125
        ]
      ],
      "plane_distance": 3418.0,
      "authentic_texture": "cbasedoor1grn"
    },
    {
      "tag": "CSlidingDoor piece: fdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "fdr2",
      "offset": 5095,
      "centroid": [
        -3435.550048828125,
        -5166.00048828125,
        986.70703125
      ],
      "bbox_min": [
        -3439.10009765625,
        -5166.00048828125,
        981.70703125
      ],
      "bbox_max": [
        -3432.0,
        -5166.00048828125,
        991.70703125
      ],
      "dimensions_source": {
        "span_x": 7.10009765625,
        "span_y": 0.0,
        "height_z": 10.0,
        "door_width": 7.10009765625,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3439.10009765625,
          -5166.00048828125,
          981.70703125
        ],
        [
          -3439.10009765625,
          -5166.00048828125,
          981.70703125
        ],
        [
          -3439.10009765625,
          -5166.00048828125,
          991.70703125
        ],
        [
          -3439.10009765625,
          -5166.00048828125,
          991.70703125
        ],
        [
          -3432.0,
          -5166.00048828125,
          991.70703125
        ],
        [
          -3432.0,
          -5166.00048828125,
          991.70703125
        ],
        [
          -3432.0,
          -5166.00048828125,
          981.70703125
        ],
        [
          -3432.0,
          -5166.00048828125,
          981.70703125
        ]
      ],
      "plane_distance": -5166.0005,
      "authentic_texture": "cbasedoor1grn"
    },
    {
      "tag": "CSlidingDoor piece: fdr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "fdr3",
      "offset": 5917,
      "centroid": [
        -3453.0,
        -5151.00048828125,
        986.70703125
      ],
      "bbox_min": [
        -3453.0,
        -5154.00048828125,
        981.70703125
      ],
      "bbox_max": [
        -3453.0,
        -5148.00048828125,
        991.70703125
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 6.0,
        "height_z": 10.0,
        "door_width": 6.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3453.0,
          -5154.00048828125,
          981.70703125
        ],
        [
          -3453.0,
          -5154.00048828125,
          981.70703125
        ],
        [
          -3453.0,
          -5154.00048828125,
          991.70703125
        ],
        [
          -3453.0,
          -5154.00048828125,
          991.70703125
        ],
        [
          -3453.0,
          -5148.00048828125,
          991.70703125
        ],
        [
          -3453.0,
          -5148.00048828125,
          991.70703125
        ],
        [
          -3453.0,
          -5148.00048828125,
          981.70703125
        ],
        [
          -3453.0,
          -5148.00048828125,
          981.70703125
        ]
      ],
      "plane_distance": 3453.0,
      "authentic_texture": "cbasedoor1grn"
    }
  ],
  "tutorial_messages": []
}